// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;0,700;1,400&family=Inter+Tight:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=general-sans@400,500,600,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    --background: 42 33% 93%;         /* #F4F1E8 */
    --foreground: 0 0% 10%;            /* #1A1A1A */
    --card: 42 40% 97%;                /* #FAF8F2 */
    --card-foreground: 0 0% 10%;
    --popover: 42 40% 97%;
    --popover-foreground: 0 0% 10%;
    --primary: 349 71% 17%;            /* #4A0D18 */
    --primary-foreground: 42 100% 98%; /* #FFFDF7 */
    --secondary: 42 25% 89%;           /* #EBE7DE */
    --secondary-foreground: 349 71% 17%;
    --muted: 42 25% 89%;
    --muted-foreground: 30 5% 38%;     /* #66625D */
    --accent: 82 60% 61%;              /* #A8D85D */
    --accent-foreground: 0 0% 10%;
    --destructive: 4 79% 40%;          /* #B42318 */
    --destructive-foreground: 42 100% 98%;
    --border: 40 17% 84%;              /* #DED9CF */
    --input: 40 17% 84%;
    --ring: 349 71% 17%;
    --radius: 0.75rem;
  }

  :root.dark,
  .dark {
    --background: 349 71% 7%;          /* #1A0509 */
    --foreground: 42 100% 98%;         /* #FFFDF7 */
    --card: 349 61% 12%;               /* #2E0B12 */
    --card-foreground: 42 100% 98%;
    --popover: 349 61% 12%;
    --popover-foreground: 42 100% 98%;
    --primary: 82 60% 61%;             /* #A8D85D */
    --primary-foreground: 0 0% 10%;
    --secondary: 349 46% 16%;          /* #3A0F19 */
    --secondary-foreground: 42 100% 98%;
    --muted: 349 46% 16%;              /* #3A0F19 */
    --muted-foreground: 17 11% 68%;    /* #B5A8A3 */
    --accent: 82 60% 61%;              /* #A8D85D */
    --accent-foreground: 0 0% 10%;
    --destructive: 4 79% 40%;          /* #B42318 */
    --destructive-foreground: 42 100% 98%;
    --border: 349 30% 20%;             /* rgba(255, 253, 247, 0.14) */
    --input: 349 30% 20%;
    --ring: 82 60% 61%;
  }
  * { border-color: hsl(var(--border)); }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-x-4 {
  left: 1rem;
  right: 1rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-12 {
  bottom: -3rem;
}
.-bottom-16 {
  bottom: -4rem;
}
.-bottom-20 {
  bottom: -5rem;
}
.-bottom-24 {
  bottom: -6rem;
}
.-bottom-36 {
  bottom: -9rem;
}
.-bottom-40 {
  bottom: -10rem;
}
.-left-12 {
  left: -3rem;
}
.-left-16 {
  left: -4rem;
}
.-left-20 {
  left: -5rem;
}
.-left-24 {
  left: -6rem;
}
.-left-36 {
  left: -9rem;
}
.-left-40 {
  left: -10rem;
}
.-left-\\[9px\\] {
  left: -9px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-12 {
  right: -3rem;
}
.-right-16 {
  right: -4rem;
}
.-right-20 {
  right: -5rem;
}
.-right-24 {
  right: -6rem;
}
.-right-36 {
  right: -9rem;
}
.-right-40 {
  right: -10rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-12 {
  top: -3rem;
}
.-top-16 {
  top: -4rem;
}
.-top-20 {
  top: -5rem;
}
.-top-24 {
  top: -6rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-32 {
  top: -8rem;
}
.-top-36 {
  top: -9rem;
}
.-top-40 {
  top: -10rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-4 {
  bottom: 1rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/4 {
  left: 25%;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-7 {
  left: 1.75rem;
}
.left-8 {
  left: 2rem;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\/4 {
  right: 25%;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-6 {
  right: 1.5rem;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-1\\/3 {
  top: 33.333333%;
}
.top-10 {
  top: 2.5rem;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-2\\/3 {
  top: 66.666667%;
}
.top-20 {
  top: 5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-6 {
  top: 1.5rem;
}
.top-\\[1px\\] {
  top: 1px;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[60\\%\\] {
  top: 60%;
}
.top-full {
  top: 100%;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[45\\] {
  z-index: 45;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[85\\] {
  z-index: 85;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.-m-1 {
  margin: -0.25rem;
}
.-m-4 {
  margin: -1rem;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}
.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-2 {
  margin-bottom: -0.5rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-4 {
  margin-left: -1rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[1200\\/630\\] {
  aspect-ratio: 1200/630;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[32rem\\] {
  height: 32rem;
}
.h-\\[38rem\\] {
  height: 38rem;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[560px\\] {
  height: 560px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[720px\\] {
  height: 720px;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\] {
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\] {
  height: var(--radix-select-trigger-height);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[--radix-context-menu-content-available-height\\] {
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\] {
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[55vh\\] {
  max-height: 55vh;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[calc\\(100vh-2rem\\)\\] {
  max-height: calc(100vh - 2rem);
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\] {
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[560px\\] {
  min-height: 560px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-\\[calc\\(100vh-4rem\\)\\] {
  min-height: calc(100vh - 4rem);
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[32rem\\] {
  width: 32rem;
}
.w-\\[38rem\\] {
  width: 38rem;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[560px\\] {
  width: 560px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[720px\\] {
  width: 720px;
}
.w-\\[85vw\\] {
  width: 85vw;
}
.w-\\[calc\\(100vw-2rem\\)\\] {
  width: calc(100vw - 2rem);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-9 {
  min-width: 2.25rem;
}
.min-w-\\[1080px\\] {
  min-width: 1080px;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[18px\\] {
  min-width: 18px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[260px\\] {
  min-width: 260px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[36px\\] {
  min-width: 36px;
}
.min-w-\\[640px\\] {
  min-width: 640px;
}
.min-w-\\[720px\\] {
  min-width: 720px;
}
.min-w-\\[760px\\] {
  min-width: 760px;
}
.min-w-\\[860px\\] {
  min-width: 860px;
}
.min-w-\\[8rem\\] {
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\] {
  min-width: var(--radix-select-trigger-width);
}
.min-w-full {
  min-width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[13rem\\] {
  max-width: 13rem;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[170px\\] {
  max-width: 170px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[60\\%\\] {
  max-width: 60%;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[75\\%\\] {
  max-width: 75%;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[92vw\\] {
  max-width: 92vw;
}
.max-w-\\[calc\\(100vw-3rem\\)\\] {
  max-width: calc(100vw - 3rem);
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-max {
  max-width: max-content;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.grow-0 {
  flex-grow: 0;
}
.basis-full {
  flex-basis: 100%;
}
.caption-bottom {
  caption-side: bottom;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\] {
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\] {
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\] {
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\] {
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\] {
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\] {
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\] {
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\] {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.select-all {
  -webkit-user-select: all;
          user-select: all;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.scroll-mt-20 {
  scroll-margin-top: 5rem;
}
.scroll-mt-24 {
  scroll-margin-top: 6rem;
}
.list-inside {
  list-style-position: inside;
}
.list-outside {
  list-style-position: outside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-\\[auto_1fr\\] {
  grid-template-columns: auto 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-border > :not([hidden]) ~ :not([hidden]) {
  border-color: hsl(var(--border));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-200\\/60 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(226 232 240 / 0.6);
}
.divide-slate-800 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-divide-opacity, 1));
}
.divide-slate-800\\/60 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(30 41 59 / 0.6);
}
.divide-white\\/60 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(255 255 255 / 0.6);
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre {
  white-space: pre;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[28px\\] {
  border-radius: 28px;
}
.rounded-\\[inherit\\] {
  border-radius: inherit;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: var(--radius);
}
.rounded-md {
  border-radius: calc(var(--radius) - 2px);
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
  border-top-right-radius: calc(var(--radius) - 4px);
}
.rounded-bl-sm {
  border-bottom-left-radius: calc(var(--radius) - 4px);
}
.rounded-br-sm {
  border-bottom-right-radius: calc(var(--radius) - 4px);
}
.rounded-tl-sm {
  border-top-left-radius: calc(var(--radius) - 4px);
}
.\\!border {
  border-width: 1px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-\\[\\#004C3F\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 76 63 / var(--tw-border-opacity, 1));
}
.border-\\[color\\:var\\(--pf-mint\\)\\] {
  border-color: var(--pf-mint);
}
.border-amber-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/40 {
  border-color: rgb(253 230 138 / 0.4);
}
.border-amber-200\\/60 {
  border-color: rgb(253 230 138 / 0.6);
}
.border-amber-200\\/80 {
  border-color: rgb(253 230 138 / 0.8);
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/20 {
  border-color: rgb(245 158 11 / 0.2);
}
.border-border {
  border-color: hsl(var(--border));
}
.border-cyan-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 250 254 / var(--tw-border-opacity, 1));
}
.border-cyan-100\\/60 {
  border-color: rgb(207 250 254 / 0.6);
}
.border-cyan-200 {
  --tw-border-opacity: 1;
  border-color: rgb(165 243 252 / var(--tw-border-opacity, 1));
}
.border-cyan-200\\/60 {
  border-color: rgb(165 243 252 / 0.6);
}
.border-cyan-200\\/70 {
  border-color: rgb(165 243 252 / 0.7);
}
.border-cyan-200\\/80 {
  border-color: rgb(165 243 252 / 0.8);
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}
.border-cyan-300\\/70 {
  border-color: rgb(103 232 249 / 0.7);
}
.border-cyan-400 {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.border-cyan-400\\/60 {
  border-color: rgb(34 211 238 / 0.6);
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.border-cyan-500\\/20 {
  border-color: rgb(6 182 212 / 0.2);
}
.border-cyan-500\\/30 {
  border-color: rgb(6 182 212 / 0.3);
}
.border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}
.border-destructive {
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50 {
  border-color: hsl(var(--destructive) / 0.5);
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/60 {
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-200\\/80 {
  border-color: rgb(167 243 208 / 0.8);
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2);
}
.border-foreground {
  border-color: hsl(var(--foreground));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/20 {
  border-color: rgb(99 102 241 / 0.2);
}
.border-input {
  border-color: hsl(var(--input));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-primary {
  border-color: hsl(var(--primary));
}
.border-primary\\/50 {
  border-color: hsl(var(--primary) / 0.5);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-rose-100 {
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-rose-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 164 175 / var(--tw-border-opacity, 1));
}
.border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity, 1));
}
.border-rose-500\\/20 {
  border-color: rgb(244 63 94 / 0.2);
}
.border-rose-500\\/40 {
  border-color: rgb(244 63 94 / 0.4);
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-400 {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.border-slate-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 250 252 / var(--tw-border-opacity, 1));
}
.border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-slate-800\\/60 {
  border-color: rgb(30 41 59 / 0.6);
}
.border-slate-900 {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/50 {
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60 {
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/70 {
  border-color: rgb(255 255 255 / 0.7);
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#004C3F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 76 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2BB673\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(43 182 115 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4A0D18\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(74 13 24 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E3F5EC\\]\\/70 {
  background-color: rgb(227 245 236 / 0.7);
}
.bg-\\[\\#FBF9F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 249 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[color\\:var\\(--pf-mint\\)\\] {
  background-color: var(--pf-mint);
}
.bg-\\[color\\:var\\(--pf-teal\\)\\] {
  background-color: var(--pf-teal);
}
.bg-accent {
  background-color: hsl(var(--accent));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-200\\/40 {
  background-color: rgb(253 230 138 / 0.4);
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/40 {
  background-color: rgb(255 251 235 / 0.4);
}
.bg-amber-50\\/50 {
  background-color: rgb(255 251 235 / 0.5);
}
.bg-amber-50\\/60 {
  background-color: rgb(255 251 235 / 0.6);
}
.bg-amber-50\\/70 {
  background-color: rgb(255 251 235 / 0.7);
}
.bg-amber-50\\/80 {
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/20 {
  background-color: rgb(245 158 11 / 0.2);
}
.bg-background {
  background-color: hsl(var(--background));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-border {
  background-color: hsl(var(--border));
}
.bg-card {
  background-color: hsl(var(--card));
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-200\\/40 {
  background-color: rgb(165 243 252 / 0.4);
}
.bg-cyan-300\\/30 {
  background-color: rgb(103 232 249 / 0.3);
}
.bg-cyan-400\\/90 {
  background-color: rgb(34 211 238 / 0.9);
}
.bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50\\/30 {
  background-color: rgb(236 254 255 / 0.3);
}
.bg-cyan-50\\/40 {
  background-color: rgb(236 254 255 / 0.4);
}
.bg-cyan-50\\/50 {
  background-color: rgb(236 254 255 / 0.5);
}
.bg-cyan-50\\/60 {
  background-color: rgb(236 254 255 / 0.6);
}
.bg-cyan-50\\/70 {
  background-color: rgb(236 254 255 / 0.7);
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500\\/20 {
  background-color: rgb(6 182 212 / 0.2);
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-destructive {
  background-color: hsl(var(--destructive));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-200\\/30 {
  background-color: rgb(167 243 208 / 0.3);
}
.bg-emerald-200\\/40 {
  background-color: rgb(167 243 208 / 0.4);
}
.bg-emerald-300\\/25 {
  background-color: rgb(110 231 183 / 0.25);
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/90 {
  background-color: rgb(52 211 153 / 0.9);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40 {
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/60 {
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-50\\/70 {
  background-color: rgb(236 253 245 / 0.7);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15 {
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/20 {
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-500\\/90 {
  background-color: rgb(16 185 129 / 0.9);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-foreground {
  background-color: hsl(var(--foreground));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-muted {
  background-color: hsl(var(--muted));
}
.bg-muted\\/50 {
  background-color: hsl(var(--muted) / 0.5);
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-popover {
  background-color: hsl(var(--popover));
}
.bg-primary {
  background-color: hsl(var(--primary));
}
.bg-primary\\/10 {
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20 {
  background-color: hsl(var(--primary) / 0.2);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/70 {
  background-color: rgb(254 242 242 / 0.7);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-950\\/50 {
  background-color: rgb(69 10 10 / 0.5);
}
.bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/40 {
  background-color: rgb(255 241 242 / 0.4);
}
.bg-rose-50\\/50 {
  background-color: rgb(255 241 242 / 0.5);
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-rose-500\\/10 {
  background-color: rgb(244 63 94 / 0.1);
}
.bg-rose-500\\/20 {
  background-color: rgb(244 63 94 / 0.2);
}
.bg-rose-500\\/30 {
  background-color: rgb(244 63 94 / 0.3);
}
.bg-rose-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-rose-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  background-color: hsl(var(--secondary));
}
.bg-secondary\\/40 {
  background-color: hsl(var(--secondary) / 0.4);
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-400\\/70 {
  background-color: rgb(148 163 184 / 0.7);
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/40 {
  background-color: rgb(248 250 252 / 0.4);
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60 {
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/70 {
  background-color: rgb(30 41 59 / 0.7);
}
.bg-slate-800\\/80 {
  background-color: rgb(30 41 59 / 0.8);
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/40 {
  background-color: rgb(15 23 42 / 0.4);
}
.bg-slate-900\\/50 {
  background-color: rgb(15 23 42 / 0.5);
}
.bg-slate-900\\/60 {
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-900\\/70 {
  background-color: rgb(15 23 42 / 0.7);
}
.bg-slate-900\\/80 {
  background-color: rgb(15 23 42 / 0.8);
}
.bg-slate-900\\/90 {
  background-color: rgb(15 23 42 / 0.9);
}
.bg-slate-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-slate-950\\/80 {
  background-color: rgb(2 6 23 / 0.8);
}
.bg-slate-950\\/85 {
  background-color: rgb(2 6 23 / 0.85);
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/85 {
  background-color: rgb(255 255 255 / 0.85);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-amber-100 {
  --tw-gradient-from: #fef3c7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 243 199 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50 {
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50\\/40 {
  --tw-gradient-from: rgb(255 251 235 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500\\/15 {
  --tw-gradient-from: rgb(245 158 11 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/20 {
  --tw-gradient-from: rgb(0 0 0 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/40 {
  --tw-gradient-from: rgb(0 0 0 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/50 {
  --tw-gradient-from: rgb(0 0 0 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-100 {
  --tw-gradient-from: #cffafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(207 250 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400 {
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50 {
  --tw-gradient-from: #ecfeff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50\\/60 {
  --tw-gradient-from: rgb(236 254 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50\\/70 {
  --tw-gradient-from: rgb(236 254 255 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-50\\/80 {
  --tw-gradient-from: rgb(236 254 255 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500\\/15 {
  --tw-gradient-from: rgb(6 182 212 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-100 {
  --tw-gradient-from: #d1fae5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 250 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-200 {
  --tw-gradient-from: #a7f3d0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(167 243 208 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400 {
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50 {
  --tw-gradient-from: #ecfdf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500\\/15 {
  --tw-gradient-from: rgb(16 185 129 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-400 {
  --tw-gradient-from: #e879f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(232 121 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500\\/15 {
  --tw-gradient-from: rgb(99 102 241 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-100 {
  --tw-gradient-from: #ffedd5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 237 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-400 {
  --tw-gradient-from: #f472b6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 114 182 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-100 {
  --tw-gradient-from: #ffe4e6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 228 230 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-50 {
  --tw-gradient-from: #fff1f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 241 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-rose-500\\/15 {
  --tw-gradient-from: rgb(244 63 94 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-100 {
  --tw-gradient-from: #f1f5f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 245 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-500 {
  --tw-gradient-from: #64748b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(100 116 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900 {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50 {
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500 {
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/40 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-50 {
  --tw-gradient-to: rgb(236 254 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ecfeff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-50\\/40 {
  --tw-gradient-to: rgb(236 254 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(236 254 255 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-950 {
  --tw-gradient-to: rgb(8 51 68 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #083344 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-500 {
  --tw-gradient-to: rgb(16 185 129 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #10b981 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-100 {
  --tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);
}
.to-amber-100\\/60 {
  --tw-gradient-to: rgb(254 243 199 / 0.6) var(--tw-gradient-to-position);
}
.to-amber-50 {
  --tw-gradient-to: #fffbeb var(--tw-gradient-to-position);
}
.to-amber-500\\/0 {
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
}
.to-black\\/70 {
  --tw-gradient-to: rgb(0 0 0 / 0.7) var(--tw-gradient-to-position);
}
.to-cyan-100 {
  --tw-gradient-to: #cffafe var(--tw-gradient-to-position);
}
.to-cyan-100\\/60 {
  --tw-gradient-to: rgb(207 250 254 / 0.6) var(--tw-gradient-to-position);
}
.to-cyan-200 {
  --tw-gradient-to: #a5f3fc var(--tw-gradient-to-position);
}
.to-cyan-50 {
  --tw-gradient-to: #ecfeff var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-500\\/0 {
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-100 {
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-100\\/60 {
  --tw-gradient-to: rgb(209 250 229 / 0.6) var(--tw-gradient-to-position);
}
.to-emerald-400 {
  --tw-gradient-to: #34d399 var(--tw-gradient-to-position);
}
.to-emerald-50 {
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-emerald-50\\/60 {
  --tw-gradient-to: rgb(236 253 245 / 0.6) var(--tw-gradient-to-position);
}
.to-emerald-500 {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-emerald-500\\/0 {
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-indigo-500\\/0 {
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
}
.to-orange-100 {
  --tw-gradient-to: #ffedd5 var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-rose-100\\/60 {
  --tw-gradient-to: rgb(255 228 230 / 0.6) var(--tw-gradient-to-position);
}
.to-rose-500 {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-rose-500\\/0 {
  --tw-gradient-to: rgb(244 63 94 / 0) var(--tw-gradient-to-position);
}
.to-sky-100 {
  --tw-gradient-to: #e0f2fe var(--tw-gradient-to-position);
}
.to-sky-50\\/50 {
  --tw-gradient-to: rgb(240 249 255 / 0.5) var(--tw-gradient-to-position);
}
.to-slate-100\\/60 {
  --tw-gradient-to: rgb(241 245 249 / 0.6) var(--tw-gradient-to-position);
}
.to-slate-200 {
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-50 {
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-slate-600 {
  --tw-gradient-to: #475569 var(--tw-gradient-to-position);
}
.to-slate-800 {
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}
.to-slate-900 {
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-100 {
  --tw-gradient-to: #ccfbf1 var(--tw-gradient-to-position);
}
.to-teal-500 {
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-100\\/60 {
  --tw-gradient-to: rgb(237 233 254 / 0.6) var(--tw-gradient-to-position);
}
.to-violet-50 {
  --tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);
}
.to-violet-600 {
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-yellow-200 {
  --tw-gradient-to: #fef08a var(--tw-gradient-to-position);
}
.fill-current {
  fill: currentColor;
}
.fill-primary {
  fill: hsl(var(--primary));
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-12 {
  padding: 3rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[1px\\] {
  padding: 1px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.05\\] {
  line-height: 1.05;
}
.leading-\\[1\\] {
  line-height: 1;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.02em\\] {
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.035em\\] {
  letter-spacing: -0.035em;
}
.tracking-\\[-0\\.03em\\] {
  letter-spacing: -0.03em;
}
.tracking-\\[0\\.15em\\] {
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.22em\\] {
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.2em\\] {
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tighter {
  letter-spacing: -0.05em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#004C3F\\] {
  --tw-text-opacity: 1;
  color: rgb(0 76 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a0dab\\] {
  --tw-text-opacity: 1;
  color: rgb(26 13 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4A0D18\\] {
  --tw-text-opacity: 1;
  color: rgb(74 13 24 / var(--tw-text-opacity, 1));
}
.text-accent-foreground {
  color: hsl(var(--accent-foreground));
}
.text-amber-100 {
  --tw-text-opacity: 1;
  color: rgb(254 243 199 / var(--tw-text-opacity, 1));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-background {
  color: hsl(var(--background));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-card-foreground {
  color: hsl(var(--card-foreground));
}
.text-current {
  color: currentColor;
}
.text-cyan-100 {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity, 1));
}
.text-cyan-200 {
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-cyan-400 {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.text-cyan-950 {
  --tw-text-opacity: 1;
  color: rgb(8 51 68 / var(--tw-text-opacity, 1));
}
.text-destructive {
  color: hsl(var(--destructive));
}
.text-destructive-foreground {
  color: hsl(var(--destructive-foreground));
}
.text-emerald-100 {
  --tw-text-opacity: 1;
  color: rgb(209 250 229 / var(--tw-text-opacity, 1));
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-emerald-950 {
  --tw-text-opacity: 1;
  color: rgb(2 44 34 / var(--tw-text-opacity, 1));
}
.text-foreground {
  color: hsl(var(--foreground));
}
.text-foreground\\/50 {
  color: hsl(var(--foreground) / 0.5);
}
.text-indigo-100 {
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-popover-foreground {
  color: hsl(var(--popover-foreground));
}
.text-primary {
  color: hsl(var(--primary));
}
.text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-100 {
  --tw-text-opacity: 1;
  color: rgb(255 228 230 / var(--tw-text-opacity, 1));
}
.text-rose-200\\/80 {
  color: rgb(254 205 211 / 0.8);
}
.text-rose-300 {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.text-rose-300\\/80 {
  color: rgb(253 164 175 / 0.8);
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-400\\/80 {
  color: rgb(251 113 133 / 0.8);
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-rose-800 {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.text-rose-900 {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-secondary-foreground {
  color: hsl(var(--secondary-foreground));
}
.text-sky-800 {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-slate-100 {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-slate-950 {
  --tw-text-opacity: 1;
  color: rgb(2 6 23 / var(--tw-text-opacity, 1));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-800 {
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-slate-300 {
  text-decoration-color: #cbd5e1;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.placeholder-slate-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.accent-cyan-600 {
  accent-color: #0891b2;
}
.accent-cyan-700 {
  accent-color: #0e7490;
}
.opacity-0 {
  opacity: 0;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-\\[0\\.03\\] {
  opacity: 0.03;
}
.opacity-\\[0\\.04\\] {
  opacity: 0.04;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cyan-500\\/10 {
  --tw-shadow-color: rgb(6 182 212 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20 {
  --tw-shadow-color: rgb(6 182 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/30 {
  --tw-shadow-color: rgb(6 182 212 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-900\\/20 {
  --tw-shadow-color: rgb(22 78 99 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-amber-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-amber-300\\/70 {
  --tw-ring-color: rgb(252 211 77 / 0.7);
}
.ring-cyan-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(207 250 254 / var(--tw-ring-opacity, 1));
}
.ring-cyan-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity, 1));
}
.ring-cyan-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}
.ring-cyan-400\\/60 {
  --tw-ring-color: rgb(34 211 238 / 0.6);
}
.ring-cyan-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}
.ring-emerald-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 243 208 / var(--tw-ring-opacity, 1));
}
.ring-emerald-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(52 211 153 / var(--tw-ring-opacity, 1));
}
.ring-emerald-400\\/60 {
  --tw-ring-color: rgb(52 211 153 / 0.6);
}
.ring-orange-200\\/80 {
  --tw-ring-color: rgb(254 215 170 / 0.8);
}
.ring-red-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}
.ring-ring {
  --tw-ring-color: hsl(var(--ring));
}
.ring-rose-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 205 211 / var(--tw-ring-opacity, 1));
}
.ring-rose-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 164 175 / var(--tw-ring-opacity, 1));
}
.ring-rose-300\\/70 {
  --tw-ring-color: rgb(253 164 175 / 0.7);
}
.ring-sky-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(186 230 253 / var(--tw-ring-opacity, 1));
}
.ring-slate-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-300\\/70 {
  --tw-ring-color: rgb(203 213 225 / 0.7);
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/60 {
  --tw-ring-color: rgb(255 255 255 / 0.6);
}
.ring-white\\/70 {
  --tw-ring-color: rgb(255 255 255 / 0.7);
}
.ring-offset-background {
  --tw-ring-offset-color: hsl(var(--background));
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md {
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm {
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter {

  from {
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit {

  to {
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in {
  --tw-enter-opacity: 0;
}
.fade-in-0 {
  --tw-enter-opacity: 0;
}
.zoom-in-95 {
  --tw-enter-scale: .95;
}
.slide-in-from-bottom-2 {
  --tw-enter-translate-y: 0.5rem;
}
.duration-1000 {
  animation-duration: 1000ms;
}
.duration-200 {
  animation-duration: 200ms;
}
.duration-300 {
  animation-duration: 300ms;
}
.duration-500 {
  animation-duration: 500ms;
}
.ease-in-out {
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.\\!running {
  animation-play-state: running !important;
}
.running {
  animation-play-state: running;
}
.paused {
  animation-play-state: paused;
}
.\\[mask-image\\:linear-gradient\\(to_right\\2c transparent\\2c black_12\\%\\2c black_88\\%\\2c transparent\\)\\] {
  mask-image: linear-gradient(to right,transparent,black 12%,black 88%,transparent);
}
.\\[overflow-wrap\\:anywhere\\] {
  overflow-wrap: anywhere;
}

/* Fonts: Cormorant Garamond for editorial display, General Sans for UI, JetBrains Mono for data */

/* ================================================================
   CYANNECT · Premium Burgundy + Cream Design Tokens (iter 61)
   60% cream/ivory · 25% burgundy · 10% ink · 5% green accent
   All --pf-* aliases retained so existing component classes work.
   ================================================================ */
:root {
  /* ---- Primary palette (spec §PRIMARY) ---- */
  --cy-burgundy:       #4A0D18;   /* Primary dark burgundy */
  --cy-burgundy-dark:  #2E0B12;   /* Deep burgundy — depth surfaces, footer */
  --cy-bg:             #F4F1E8;   /* Warm cream — main page bg */
  --cy-surface:        #FAF8F2;   /* Soft ivory — cards, elevated */
  --cy-text:           #1A1A1A;   /* Primary text */
  --cy-text-body:      #3F3D39;   /* Body */
  --cy-text-muted:     #66625D;   /* Secondary text */
  --cy-text-on-dark:   #FFFDF7;   /* Cream text on burgundy */
  --cy-text-on-dark-muted: #D8C8C5; /* Muted on burgundy */
  --cy-accent:         #A8D85D;   /* Cyannect accent green — actions/rewards */
  --cy-accent-hover:   #B7E66B;
  --cy-accent-active:  #94C64F;
  --cy-border:         #DED9CF;   /* Light border */
  --cy-border-strong:  #CEC8BE;   /* Input border */
  --cy-muted-bg:       #EBE7DE;   /* Muted section bg */
  --cy-success:        #2F7D4A;
  --cy-error:          #B42318;
  --cy-warning:        #B7791F;
  --cy-placeholder:    #8A857D;
  --cy-focus-ring:     rgba(74, 13, 24, 0.15);

  /* Supporting chart palette (spec §15) */
  --cy-chart-burgundy: #4A0D18;
  --cy-chart-green:    #A8D85D;
  --cy-chart-mburg:    #8A4550;
  --cy-chart-gold:     #D6A84B;
  --cy-chart-gray:     #AAA39A;
  --cy-chart-dark:     #2E0B12;

  /* ---- Legacy --pf-* aliases (unchanged names, remapped values) ---- */
  --pf-bg:          var(--cy-bg);
  --pf-bg-2:        var(--cy-surface);
  --pf-bg-3:        #FFFFFF;

  --pf-forest-dark: var(--cy-burgundy-dark);
  --pf-forest:      var(--cy-burgundy);
  --pf-green:       var(--cy-accent);
  --pf-green-2:     var(--cy-accent-hover);
  --pf-sage:        var(--cy-muted-bg);
  --pf-mint:        var(--cy-accent);
  --pf-cream:       var(--cy-bg);

  --pf-ink:         var(--cy-text);
  --pf-ink-2:       var(--cy-text-body);
  --pf-mute:        var(--cy-text-muted);
  --pf-mute-2:      var(--cy-placeholder);

  /* Glass surface system — subtle so cards keep a warm cream feel */
  --pf-glass:       rgba(255, 253, 247, 0.88);
  --pf-glass-2:     rgba(244, 241, 232, 0.72);
  --pf-glass-line:  rgba(74, 13, 24, 0.12);

  --pf-shadow:      0 20px 50px -15px rgba(46, 11, 18, 0.10);
  --pf-shadow-sm:   0 4px 20px rgba(46, 11, 18, 0.06);

  --pf-gradient:    linear-gradient(135deg, #2E0B12 0%, #4A0D18 60%, #5C1422 100%);
  --pf-gradient-hero:
    radial-gradient(70% 60% at 20% 15%, rgba(74, 13, 24, 0.04), transparent 65%),
    radial-gradient(60% 50% at 80% 85%, rgba(235, 231, 222, 0.6), transparent 70%),
    linear-gradient(180deg, #F4F1E8 0%, #FAF8F2 100%);
}

/* ================================================================
   Dark mode (Deep Burgundy Night)
   ================================================================ */
:root.dark {
  --cy-bg:           #1A0509;
  --cy-surface:      #2E0B12;
  --cy-text:         #FFFDF7;
  --cy-text-body:    #E9DFD8;
  --cy-text-muted:   #B5A8A3;
  --cy-border:       rgba(255, 253, 247, 0.14);
  --cy-border-strong: rgba(255, 253, 247, 0.22);
  --cy-muted-bg:     #3A0F19;

  --pf-bg:           var(--cy-bg);
  --pf-bg-2:         var(--cy-surface);
  --pf-bg-3:         #240710;

  --pf-forest-dark:  #150408;
  --pf-forest:       #5C1422;
  --pf-green:        var(--cy-accent);
  --pf-green-2:      var(--cy-accent-hover);
  --pf-sage:         rgba(168, 216, 93, 0.15);
  --pf-cream:        var(--cy-bg);

  --pf-ink:          var(--cy-text);
  --pf-ink-2:        var(--cy-text-body);
  --pf-mute:         var(--cy-text-muted);
  --pf-mute-2:       #7E6E6A;

  --pf-glass:        rgba(46, 11, 18, 0.82);
  --pf-glass-2:      rgba(26, 5, 9, 0.65);
  --pf-glass-line:   rgba(255, 253, 247, 0.15);

  --pf-shadow:       0 20px 60px -20px rgba(0, 0, 0, 0.6);
  --pf-shadow-sm:    0 8px 24px -12px rgba(74, 13, 24, 0.35);

  --pf-gradient-hero:
    radial-gradient(60% 55% at 15% 20%, rgba(92, 20, 34, 0.35), transparent 60%),
    radial-gradient(55% 55% at 85% 15%, rgba(46, 11, 18, 0.6), transparent 60%),
    linear-gradient(180deg, #1A0509 0%, #240710 100%);
}

:root.dark,
:root.dark body {
  background: var(--pf-bg);
  color: var(--pf-ink);
  color-scheme: dark;
}

/* Dark mode text/bg fallbacks (Tailwind slate-* → burgundy palette) */
:root.dark .text-slate-900 { color: var(--pf-ink) !important; }
:root.dark .text-slate-800 { color: var(--pf-ink) !important; }
:root.dark .text-slate-700 { color: var(--pf-ink-2) !important; }
:root.dark .text-slate-600 { color: var(--pf-mute) !important; }
:root.dark .text-slate-500 { color: var(--pf-mute-2) !important; }
:root.dark .text-slate-400 { color: rgba(216, 200, 197, 0.7) !important; }
:root.dark .bg-white,
:root.dark .bg-white\\/95,
:root.dark .bg-white\\/90,
:root.dark .bg-white\\/85,
:root.dark .bg-white\\/80,
:root.dark .bg-white\\/70,
:root.dark .bg-white\\/60,
:root.dark .bg-white\\/50,
:root.dark .bg-white\\/40,
:root.dark .bg-white\\/30,
:root.dark .bg-white\\/20,
:root.dark .bg-white\\/10 { background-color: rgba(46, 11, 18, 0.75) !important; }
:root.dark .border-white\\/80,
:root.dark .border-white\\/70,
:root.dark .border-white\\/60,
:root.dark .border-white\\/50 { border-color: rgba(255, 253, 247, 0.15) !important; }
/* iter66 · slate borders/dividers → cream hairlines on dark */
:root.dark .border-slate-100,
:root.dark .border-slate-200,
:root.dark .border-slate-300 { border-color: rgba(255, 253, 247, 0.12) !important; }
:root.dark .border-t-slate-100,
:root.dark .border-t-slate-200,
:root.dark .border-b-slate-100,
:root.dark .border-b-slate-200 { border-color: rgba(255, 253, 247, 0.12) !important; }
:root.dark .divide-slate-100 > *,
:root.dark .divide-slate-200 > * { border-color: rgba(255, 253, 247, 0.10) !important; }
/* iter66 · Tailwind linear-gradient tokens that combine light cyan/emerald/violet
   into pastel pill backgrounds — force to a subtle accent-green fill so the
   uppercase stat text and icon inside stay legible on dark */
:root.dark [class*="from-cyan-50"][class*="to-emerald-50"],
:root.dark [class*="from-cyan-50"][class*="to-violet-50"],
:root.dark [class*="from-emerald-50"][class*="to-cyan-50"],
:root.dark [class*="from-emerald-50"][class*="to-violet-50"],
:root.dark [class*="from-violet-50"][class*="to-cyan-50"],
:root.dark [class*="from-violet-50"][class*="to-emerald-50"] {
  background-image: none !important;
  background-color: rgba(168, 216, 93, 0.18) !important;
  border-color: rgba(168, 216, 93, 0.4) !important;
}
:root.dark .bg-slate-100 { background-color: rgba(46, 11, 18, 0.65) !important; }
:root.dark hr, :root.dark .divide-slate-200 > * { border-color: rgba(255, 253, 247, 0.15) !important; }
:root.dark .glass-strong,
:root.dark .pf-card {
  background-color: var(--pf-glass);
  border-color: var(--pf-glass-line);
  color: var(--pf-ink);
}
:root.dark .pf-input,
:root.dark input, :root.dark textarea, :root.dark select {
  background-color: rgba(26, 5, 9, 0.8);
  border-color: rgba(255, 253, 247, 0.18);
  color: var(--pf-ink);
}
:root.dark .pf-input::placeholder,
:root.dark input::placeholder, :root.dark textarea::placeholder {
  color: rgba(216, 200, 197, 0.55);
}
:root.dark thead,
:root.dark .uppercase.tracking-widest:not([class*="bg-"]):not([class*="pf-btn"]) {
  color: rgba(216, 200, 197, 0.75) !important;
}

/* Dark mode — surface + text-on-surface overrides for named component classes
   that don't use plain Tailwind utilities. Fixes header + hero + card
   legibility flagged by the user in iter64. */
:root.dark .glass-nav {
  background-color: rgba(26, 5, 9, 0.82);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border-bottom: 1px solid rgba(255, 253, 247, 0.10);
}
:root.dark .glass,
:root.dark .glass-strong {
  background-color: rgba(46, 11, 18, 0.72);
  border-color: rgba(255, 253, 247, 0.12);
  color: var(--pf-ink);
  box-shadow:
    0 20px 60px -20px rgba(0, 0, 0, 0.6),
    inset 0 1px 0 rgba(255, 253, 247, 0.06);
}
:root.dark .pf-card {
  background: linear-gradient(180deg,
    rgba(46, 11, 18, 0.85) 0%,
    rgba(36, 7, 16, 0.75) 100%);
  border-color: rgba(255, 253, 247, 0.12);
  color: var(--pf-ink);
  box-shadow:
    0 12px 32px -12px rgba(0, 0, 0, 0.55),
    inset 0 1px 0 rgba(255, 253, 247, 0.06);
}
:root.dark .pf-card:hover {
  background: linear-gradient(180deg,
    rgba(60, 14, 24, 0.9) 0%,
    rgba(46, 11, 18, 0.82) 100%);
  border-color: rgba(168, 216, 93, 0.32);
  box-shadow:
    0 20px 50px -12px rgba(0, 0, 0, 0.7),
    inset 0 1px 0 rgba(255, 253, 247, 0.10);
}
:root.dark .pf-btn-glass,
:root.dark .pf-btn-secondary {
  background-color: rgba(46, 11, 18, 0.6);
  border-color: rgba(255, 253, 247, 0.18);
  color: var(--pf-ink);
}
:root.dark .pf-btn-glass:hover,
:root.dark .pf-btn-secondary:hover {
  background-color: rgba(74, 13, 24, 0.75);
  border-color: var(--cy-accent);
  color: var(--cy-accent);
}
:root.dark .pf-btn-burgundy {
  background: #5C1422;
  border-color: rgba(255, 253, 247, 0.18);
}
:root.dark .pf-btn-burgundy:hover { background: #6D1729; }
:root.dark .pf-chip {
  background-color: rgba(46, 11, 18, 0.75);
  border-color: rgba(255, 253, 247, 0.12);
  color: rgba(233, 223, 216, 0.9);
}
:root.dark .pf-chip-cyan {
  background: rgba(168, 216, 93, 0.14);
  border-color: rgba(168, 216, 93, 0.4);
  color: #C4E68A;
}
:root.dark .pf-chip-lav {
  background: rgba(46, 11, 18, 0.75);
  border-color: rgba(255, 253, 247, 0.12);
  color: rgba(233, 223, 216, 0.9);
}
/* pf-chip-mint (green) stays green — high contrast on dark works */

/* Hero display gradient — swap dark→dark for light→green so display headings
   stay legible on a dark burgundy background */
:root.dark .pf-gradient-text {
  background: linear-gradient(135deg, #FFFDF7 0%, #E9DFD8 50%, #C4E68A 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
:root.dark .pf-gradient-text-2 {
  background: linear-gradient(135deg, #FFFDF7 0%, #A8D85D 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Nav-specific link hover: our \`text-slate-900\` hover override handles it,
   but idle text uses \`text-slate-600\` which we already remap to muted-cream.
   Make hover crisp so links "come alive" on hover. */
:root.dark [data-testid="site-navbar"] a { color: rgba(233, 223, 216, 0.85); }
:root.dark [data-testid="site-navbar"] a:hover { color: var(--cy-text-on-dark); }

/* Coupon card discount label (solid burgundy in light) needs a bright red-cream
   in dark to stay legible against the dark burgundy card */
:root.dark [style*="rgb(74, 13, 24)"],
:root.dark [style*="#4A0D18"] { color: #F4B8C0 !important; }

/* iter65 · Legacy Tailwind color-tinted chips/badges (About.js, feature cards,
   etc.) that use direct bg-cyan-50/text-cyan-700 etc. — remap all cyan/mint/
   violet light-tint utilities to the warm-cream + green-accent palette so they
   stay legible on dark burgundy backgrounds. */
:root.dark .bg-cyan-50,
:root.dark .bg-emerald-50,
:root.dark .bg-violet-50 {
  background-color: rgba(168, 216, 93, 0.14) !important;
}
/* iter68 · opacity-variant background washes (used by ShoppersLanding Section
   \`tone="mint"\` wrapper via \`bg-emerald-50/40\`) — remap to a very faint accent
   tint so alternating page bands don't wash out cream text on dark burgundy */
:root.dark .bg-cyan-50\\/40,
:root.dark .bg-cyan-50\\/50,
:root.dark .bg-cyan-50\\/60,
:root.dark .bg-cyan-50\\/70,
:root.dark .bg-emerald-50\\/30,
:root.dark .bg-emerald-50\\/40,
:root.dark .bg-emerald-50\\/50,
:root.dark .bg-emerald-50\\/60,
:root.dark .bg-emerald-50\\/70,
:root.dark .bg-violet-50\\/40,
:root.dark .bg-violet-50\\/50 {
  background-color: rgba(168, 216, 93, 0.05) !important;
}
:root.dark .bg-cyan-100,
:root.dark .bg-emerald-100,
:root.dark .bg-violet-100 {
  background-color: rgba(168, 216, 93, 0.20) !important;
}
:root.dark .border-cyan-200,
:root.dark .border-emerald-200,
:root.dark .border-violet-200 {
  border-color: rgba(168, 216, 93, 0.35) !important;
}
:root.dark .text-cyan-700,
:root.dark .text-cyan-600,
:root.dark .text-cyan-300,
:root.dark .text-emerald-700,
:root.dark .text-emerald-600,
:root.dark .text-emerald-800,
:root.dark .text-violet-700,
:root.dark .text-violet-600 {
  color: #C4E68A !important;
}
/* Beat the earlier \`:root.dark .uppercase.tracking-widest\` rule (3 classes)
   with a 3-class combined selector so tinted uppercase chips also render green */
:root.dark .uppercase.tracking-widest.text-cyan-700,
:root.dark .uppercase.tracking-widest.text-emerald-700,
:root.dark .uppercase.tracking-widest.text-violet-700,
:root.dark .uppercase.tracking-widest.text-cyan-600,
:root.dark .uppercase.tracking-widest.text-emerald-600,
:root.dark .uppercase.tracking-widest.text-violet-600 {
  color: #C4E68A !important;
}
/* Muted amber / cream tinted surfaces (warnings, callouts) */
:root.dark .bg-amber-50,
:root.dark .bg-amber-50\\/70,
:root.dark .bg-amber-50\\/50,
:root.dark .bg-amber-100 { background-color: rgba(183, 121, 31, 0.15) !important; }
:root.dark .border-amber-200,
:root.dark .border-amber-200\\/60,
:root.dark .border-amber-200\\/40 { border-color: rgba(183, 121, 31, 0.4) !important; }
:root.dark .text-amber-800,
:root.dark .text-amber-700,
:root.dark .text-amber-600 { color: #F0C876 !important; }
/* Red danger tint */
:root.dark .bg-red-50,
:root.dark .bg-red-50\\/70 { background-color: rgba(180, 35, 24, 0.18) !important; }
:root.dark .border-red-200 { border-color: rgba(180, 35, 24, 0.4) !important; }
:root.dark .text-red-700,
:root.dark .text-red-600 { color: #F4B8C0 !important; }
:root.dark .text-red-800 { color: #FCA5A5 !important; }
/* Cream & warm ivory surface dark overrides */
:root.dark .bg-cream-50 { background-color: rgba(46, 11, 18, 0.75) !important; }
:root.dark .bg-cream-100 { background-color: rgba(58, 15, 25, 0.85) !important; }
:root.dark .border-cream-200,
:root.dark .border-cream-300 { border-color: rgba(255, 253, 247, 0.14) !important; }
:root.dark .text-burgundy-600,
:root.dark .text-burgundy-700 { color: #F4B8C0 !important; }
:root.dark .text-burgundy-800 { color: #F8D0D6 !important; }
/* Blue */
:root.dark .bg-blue-50,
:root.dark .bg-blue-50\\/70 { background-color: rgba(168, 216, 93, 0.12) !important; }
:root.dark .text-blue-700, :root.dark .text-blue-600 { color: #C4E68A !important; }
/* Brighten \`text-slate-500\` muted labels on dark burgundy so shopper page
   captions ('Running Shoes', 'Selected Jackets', etc.) don't disappear */
:root.dark .text-slate-500 { color: #C7B5B0 !important; }

/* 2026-11 · dark-mode tables + remaining light tints (user report: table columns/index unreadable) */
:root.dark thead,
:root.dark thead tr { background-color: rgba(58, 15, 25, 0.7) !important; }
:root.dark thead th,
:root.dark thead th * { color: #E9DFD8 !important; }
:root.dark tbody tr:hover { background-color: rgba(255, 253, 247, 0.04); }
:root.dark .bg-slate-50,
:root.dark .bg-slate-50\\/40,
:root.dark .bg-slate-50\\/50,
:root.dark .bg-slate-50\\/60,
:root.dark .bg-gray-50 { background-color: rgba(58, 15, 25, 0.6) !important; }
:root.dark .bg-slate-200 { background-color: rgba(255, 253, 247, 0.10) !important; }
:root.dark .bg-rose-50,
:root.dark .bg-rose-50\\/40,
:root.dark .bg-rose-100,
:root.dark .bg-red-100 { background-color: rgba(180, 35, 24, 0.18) !important; }
:root.dark .bg-sky-50,
:root.dark .bg-indigo-50,
:root.dark .bg-purple-50,
:root.dark .bg-cyan-50\\/40 { background-color: rgba(168, 216, 93, 0.10) !important; }
:root.dark .bg-orange-50,
:root.dark .bg-amber-50\\/40,
:root.dark .bg-amber-50\\/60 { background-color: rgba(183, 121, 31, 0.15) !important; }
:root.dark .bg-emerald-200\\/40,
:root.dark .bg-cyan-200\\/40 { background-color: rgba(168, 216, 93, 0.16) !important; }
:root.dark .border-rose-200,
:root.dark .border-red-100,
:root.dark .border-rose-100 { border-color: rgba(180, 35, 24, 0.4) !important; }
:root.dark .border-sky-200,
:root.dark .border-indigo-200,
:root.dark .border-cyan-100,
:root.dark .border-emerald-100 { border-color: rgba(168, 216, 93, 0.3) !important; }
:root.dark .text-cyan-800,
:root.dark .text-cyan-900,
:root.dark .text-cyan-950,
:root.dark .text-emerald-900,
:root.dark .text-sky-700,
:root.dark .text-sky-800,
:root.dark .text-indigo-700,
:root.dark .text-teal-700,
:root.dark .text-green-700,
:root.dark .text-\\[\\#004C3F\\] { color: #C4E68A !important; }
:root.dark .text-rose-600,
:root.dark .text-rose-700,
:root.dark .text-rose-800,
:root.dark .text-red-900 { color: #F4B8C0 !important; }
:root.dark .text-amber-900,
:root.dark .text-orange-700 { color: #F0C876 !important; }
/* Selected filter pills use bg-foreground (cream in dark) — keep their label dark so it stays readable */
:root.dark .bg-foreground.text-background { color: #1A0509 !important; }
:root.dark .pf-btn-primary:disabled { color: var(--cy-text-muted) !important; }
/* Dark ink on bright fills (amber/lime/emerald buttons) must stay dark */
:root.dark [class*="bg-amber-400"].text-slate-900,
:root.dark [class*="bg-amber-500"].text-slate-900,
:root.dark [class*="bg-yellow-400"].text-slate-900,
:root.dark [class*="bg-lime-400"].text-slate-900,
:root.dark [class*="bg-emerald-400"].text-slate-900 { color: #1A1A1A !important; }
/* Sidebar "New / Preview" badge on the active (green) admin nav link */
:root.dark aside a.pf-btn-primary[aria-current="page"] [data-testid\$="-badge"] {
  background-color: rgba(26, 5, 9, 0.18) !important;
  color: #1A1A1A !important;
}
:root.dark .bg-\\[\\#E3F5EC\\]\\/70 { background-color: rgba(168, 216, 93, 0.12) !important; }
:root.dark [data-testid="site-navbar"] a.pf-btn-primary { color: #1A1A1A; }
:root.dark .text-\\[\\#4A0D18\\] { color: #F4B8C0 !important; }
:root.dark .text-orange-800 { color: #F0C876 !important; }
/* White labels on bright cyan/emerald pills (selected filters, "Most popular") — dark ink reads better on dark pages */
:root.dark .bg-cyan-500.text-white,
:root.dark .bg-emerald-500.text-white { color: #1A0509 !important; }
/* Form fields flagged with a mistake keep a visible red outline on dark pages */
:root.dark [aria-invalid="true"] { border-color: #F4B8C0 !important; }
/* Light hover tints (hover:bg-white*, hover:bg-slate-50/100) would flash a pale box under light text — keep them dark */
:root.dark .hover\\:bg-white:hover,
:root.dark .hover\\:bg-white\\/80:hover,
:root.dark .hover\\:bg-white\\/70:hover,
:root.dark .hover\\:bg-white\\/60:hover,
:root.dark .hover\\:bg-white\\/50:hover,
:root.dark .hover\\:bg-white\\/40:hover,
:root.dark .hover\\:bg-slate-50:hover,
:root.dark .hover\\:bg-slate-100:hover,
:root.dark .hover\\:bg-gray-50:hover,
:root.dark .hover\\:bg-gray-100:hover { background-color: rgba(255, 253, 247, 0.07) !important; }

/* ================================================================
   Shadcn base variables map
   ================================================================ */

html, body, #root { height: 100%; }

body {
  margin: 0;
  font-family: "General Sans", "Inter Tight", -apple-system, BlinkMacSystemFont, sans-serif;
  color: var(--cy-text);
  background: var(--cy-bg);
  background-image: var(--pf-gradient-hero);
  background-attachment: fixed;
  -webkit-font-smoothing: antialiased;
  color-scheme: light;
}

/* Editorial serif heading option for marketing display */
.font-serif-display {
  font-family: "Cormorant Garamond", Georgia, serif;
  letter-spacing: -0.015em;
  font-weight: 600;
}

h1, h2, h3, h4, .font-display {
  font-family: "General Sans", sans-serif;
  letter-spacing: -0.025em;
  font-weight: 600;
  color: var(--cy-text);
}

.font-mono {
  font-family: "JetBrains Mono", monospace;
  letter-spacing: -0.02em;
}

::selection {
  background: var(--cy-burgundy);
  color: var(--cy-text-on-dark);
}

/* ================================================================
   Decorative background blobs — richer for the glass effect
   ================================================================ */
.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.55;
  pointer-events: none;
  z-index: 0;
}
.blob-cyan { background: radial-gradient(circle, rgba(74, 13, 24, 0.55) 0%, transparent 70%); }
.blob-mint { background: radial-gradient(circle, rgba(235, 231, 222, 0.95) 0%, transparent 70%); }
.blob-lav  { background: radial-gradient(circle, rgba(168, 216, 93, 0.45) 0%, transparent 70%); }
.blob-rose { background: radial-gradient(circle, rgba(92, 20, 34, 0.50) 0%, transparent 70%); }

@keyframes blob-float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  33%      { transform: translate(24px, -30px) scale(1.08); }
  66%      { transform: translate(-24px, 16px) scale(0.96); }
}
.blob-float { animation: blob-float 20s ease-in-out infinite; }

/* ================================================================
   Gradient text — used sparingly for hero accents
   ================================================================ */
.pf-gradient-text {
  background: linear-gradient(135deg, #2E0B12 0%, #4A0D18 50%, #6B1526 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}
.pf-gradient-text-2 {
  background: linear-gradient(135deg, #4A0D18 0%, #A8D85D 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.pf-gradient-bg {
  background: linear-gradient(135deg, #2E0B12 0%, #4A0D18 60%, #5C1422 100%);
}

/* ================================================================
   Glass surfaces (iter62) — genuine frosted-glass morphism
   Translucent cream + heavy backdrop blur + burgundy border tint
   ================================================================ */
.glass {
  background-color: rgba(255, 253, 247, 0.55);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border: 1px solid rgba(255, 253, 247, 0.7);
  box-shadow:
    0 8px 32px -8px rgba(46, 11, 18, 0.12),
    inset 0 1px 0 0 rgba(255, 255, 255, 0.85);
}
.glass-strong {
  background-color: rgba(250, 248, 242, 0.72);
  backdrop-filter: blur(32px) saturate(200%);
  -webkit-backdrop-filter: blur(32px) saturate(200%);
  border: 1px solid rgba(255, 253, 247, 0.85);
  box-shadow:
    0 20px 50px -15px rgba(46, 11, 18, 0.18),
    inset 0 1px 0 0 rgba(255, 255, 255, 1),
    inset 0 -1px 0 0 rgba(74, 13, 24, 0.04);
}
.glass-nav {
  background-color: rgba(244, 241, 232, 0.65);
  backdrop-filter: blur(28px) saturate(180%);
  -webkit-backdrop-filter: blur(28px) saturate(180%);
  border-bottom: 1px solid rgba(255, 253, 247, 0.7);
  box-shadow: 0 4px 20px -8px rgba(46, 11, 18, 0.05);
}

/* ================================================================
   Cards (§6 + glass upgrade) — translucent ivory frost with
   burgundy-tinted border + hover lift
   ================================================================ */
.pf-card {
  background: linear-gradient(180deg,
    rgba(255, 253, 247, 0.72) 0%,
    rgba(250, 248, 242, 0.58) 100%);
  backdrop-filter: blur(24px) saturate(160%);
  -webkit-backdrop-filter: blur(24px) saturate(160%);
  border: 1px solid rgba(255, 253, 247, 0.9);
  border-radius: 16px;
  box-shadow:
    0 6px 24px -8px rgba(46, 11, 18, 0.10),
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    inset 0 -1px 0 rgba(74, 13, 24, 0.03);
  transition:
    transform 260ms ease,
    box-shadow 260ms ease,
    border-color 260ms ease,
    background 260ms ease;
}
.pf-card:hover {
  transform: translateY(-2px);
  background: linear-gradient(180deg,
    rgba(255, 253, 247, 0.85) 0%,
    rgba(250, 248, 242, 0.72) 100%);
  box-shadow:
    0 16px 40px -12px rgba(46, 11, 18, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 1),
    inset 0 -1px 0 rgba(74, 13, 24, 0.05);
  border-color: rgba(74, 13, 24, 0.22);
}

/* ================================================================
   Buttons (§4 & §5)
   - .pf-btn-primary  → green accent CTA (Reveal, Get Deal, Sign in…)
   - .pf-btn-burgundy → burgundy secondary on light bg
   - .pf-btn-glass    → subtle secondary on cream
   ================================================================ */
.pf-btn-primary {
  background: var(--cy-accent);
  color: #1A1A1A;
  font-weight: 600;
  border: 1px solid rgba(74, 13, 24, 0.08);
  border-radius: 12px;
  box-shadow:
    0 4px 14px -4px rgba(94, 118, 44, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
  transition:
    background-color 160ms ease,
    transform 140ms ease,
    box-shadow 200ms ease;
}
.pf-btn-primary:hover {
  background: var(--cy-accent-hover);
  box-shadow:
    0 8px 22px -6px rgba(94, 118, 44, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
}
.pf-btn-primary:active {
  background: var(--cy-accent-active);
  transform: scale(0.98);
}
.pf-btn-primary:disabled {
  background: var(--cy-muted-bg);
  color: var(--cy-text-muted);
  box-shadow: none;
  cursor: not-allowed;
}
:root.dark .pf-btn-primary {
  color: #1A1A1A;
}

/* Burgundy button — secondary action on light bg */
.pf-btn-burgundy {
  background: var(--cy-burgundy);
  color: var(--cy-text-on-dark);
  font-weight: 600;
  border: 1px solid rgba(46, 11, 18, 0.6);
  border-radius: 12px;
  box-shadow:
    0 4px 14px -4px rgba(46, 11, 18, 0.35),
    inset 0 1px 0 rgba(255, 253, 247, 0.15);
  transition: background-color 160ms ease, transform 140ms ease, box-shadow 200ms ease;
}
.pf-btn-burgundy:hover { background: #5C1422; }
.pf-btn-burgundy:active { background: var(--cy-burgundy-dark); transform: scale(0.98); }

/* Glass / secondary button on cream */
.pf-btn-glass {
  background-color: var(--cy-surface);
  border: 1px solid var(--cy-border);
  color: var(--cy-text);
  font-weight: 600;
  border-radius: 12px;
  transition:
    background-color 200ms ease,
    border-color 200ms ease,
    color 200ms ease;
}
.pf-btn-glass:hover {
  background-color: var(--cy-muted-bg);
  border-color: var(--cy-burgundy);
  color: var(--cy-burgundy);
}

.pf-btn-secondary {
  background: var(--cy-surface);
  color: var(--cy-burgundy);
  border: 1px solid var(--cy-border);
  border-radius: 12px;
  font-weight: 600;
  transition: background-color 180ms ease, border-color 180ms ease;
}
.pf-btn-secondary:hover {
  background: var(--cy-muted-bg);
  border-color: var(--cy-burgundy);
}

/* ================================================================
   Chips (§10 + §general) — burgundy pills for badges,
   green pills for cashback/accent, cream for neutral
   ================================================================ */
.pf-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--cy-muted-bg);
  border: 1px solid var(--cy-border);
  color: var(--cy-burgundy);
  box-shadow: 0 2px 6px rgba(46, 11, 18, 0.04);
}
/* Legacy chip variants remapped to the new palette */
.pf-chip-cyan {  /* → burgundy badge */
  background: var(--cy-burgundy);
  border-color: var(--cy-burgundy-dark);
  color: var(--cy-text-on-dark);
}
.pf-chip-lav {   /* → warm cream badge */
  background: var(--cy-muted-bg);
  border-color: var(--cy-border);
  color: var(--cy-burgundy);
}
.pf-chip-mint {  /* → green accent — cashback / rewards */
  background: var(--cy-accent);
  border-color: rgba(74, 13, 24, 0.15);
  color: var(--cy-text);
}

/* ================================================================
   Divider · Marquee · Fade · Gradient shift
   ================================================================ */
.pf-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(74, 13, 24, 0.2), transparent);
  margin: 0 auto;
  max-width: 90rem;
}

.marquee { animation: marquee 45s linear infinite; }
@keyframes marquee {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
}
.fade-up { animation: fadeUp 600ms ease both; }

@keyframes gradient-shift {
  0%, 100% { background-position: 0% 50%; }
  50%      { background-position: 100% 50%; }
}
.gradient-shift {
  background-size: 200% 200%;
  animation: gradient-shift 10s ease infinite;
}

/* ================================================================
   Inputs (§11)
   ================================================================ */
.pf-input {
  background: rgba(250, 248, 242, 0.72);
  backdrop-filter: blur(12px) saturate(140%);
  -webkit-backdrop-filter: blur(12px) saturate(140%);
  border: 1px solid rgba(74, 13, 24, 0.15);
  color: var(--cy-text);
  border-radius: 10px;
  transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}
.pf-input::placeholder { color: var(--cy-placeholder); }
.pf-input:focus {
  outline: none;
  border-color: var(--cy-burgundy);
  box-shadow: 0 0 0 4px var(--cy-focus-ring);
}
.pf-input:disabled {
  background: var(--cy-muted-bg);
  color: var(--cy-text-muted);
}
.pf-input[aria-invalid="true"],
.pf-input.error {
  border-color: var(--cy-error);
  box-shadow: 0 0 0 4px rgba(180, 35, 24, 0.12);
}

/* ================================================================
   Scrollbar
   ================================================================ */
::-webkit-scrollbar { width: 10px; height: 10px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb {
  background: rgba(74, 13, 24, 0.28);
  border-radius: 8px;
}
::-webkit-scrollbar-thumb:hover { background: rgba(74, 13, 24, 0.5); }

.tabular-nums { font-variant-numeric: tabular-nums; }

/* ================================================================
   Shimmer sweep — used on featured cards, warmed for cream base
   ================================================================ */
.shimmer {
  position: relative;
  overflow: hidden;
  isolation: isolate;
}
.shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    115deg,
    transparent 30%,
    rgba(255, 253, 247, 0.55) 48%,
    rgba(235, 231, 222, 0.35) 52%,
    transparent 70%
  );
  background-size: 250% 100%;
  background-position: 200% 0;
  pointer-events: none;
  animation: shimmer-sweep 4.5s ease-in-out infinite;
  mix-blend-mode: overlay;
  z-index: 1;
}
@keyframes shimmer-sweep {
  0%   { background-position: 200% 0; }
  55%  { background-position: -50% 0; }
  100% { background-position: -50% 0; }
}
.shimmer > * { position: relative; z-index: 2; }

/* ================================================================
   Burgundy console sidebar (§8) — used by merchant portal via
   <PortalShell variant="burgundy">. Dark burgundy surface with
   accent-green pill highlight on the selected tab.
   ================================================================ */
.console-burgundy {
  background: linear-gradient(180deg, #2E0B12 0%, #4A0D18 100%);
  border: 1px solid rgba(255, 253, 247, 0.08);
  color: var(--cy-text-on-dark);
  box-shadow:
    0 20px 50px -15px rgba(46, 11, 18, 0.45),
    inset 0 1px 0 rgba(255, 253, 247, 0.06);
  /* No blur — solid burgundy console reads more premium than a translucent one */
}

.console-burgundy__eyebrow {
  color: rgba(216, 200, 197, 0.75);
}
.console-burgundy__title {
  color: var(--cy-text-on-dark);
}

.console-burgundy__link {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 0.875rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--cy-text-on-dark-muted);
  position: relative;
  transition:
    background-color 180ms ease,
    color 180ms ease,
    padding-left 180ms ease;
}
.console-burgundy__link:hover {
  background: rgba(255, 253, 247, 0.08);
  color: var(--cy-text-on-dark);
}
.console-burgundy__link--active {
  background: rgba(255, 253, 247, 0.10);
  color: var(--cy-text-on-dark);
  padding-left: 1.125rem;
}
/* Green accent indicator bar on the active tab (spec §8) */
.console-burgundy__link--active::before {
  content: "";
  position: absolute;
  left: 0.375rem;
  top: 25%;
  bottom: 25%;
  width: 3px;
  border-radius: 4px;
  background: var(--cy-accent);
  box-shadow: 0 0 12px rgba(168, 216, 93, 0.6);
}
/* Icon color follows text; boost the active-state icon */
.console-burgundy__link svg { color: currentColor; }
.console-burgundy__link--active svg { color: var(--cy-accent); }

:root.dark .console-burgundy {
  background: linear-gradient(180deg, #180508 0%, #2E0B12 100%);
}

/* Floating helpers step aside while a dialog or sheet is open. */
body[data-scroll-locked] .support-chat-launcher-btn,
body[data-scroll-locked] [data-testid="analytics-consent-banner"] { display: none !important; }
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button {
  background-color: transparent;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button {
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button {
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::placeholder {
  color: hsl(var(--muted-foreground));
}
.placeholder\\:text-slate-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after {
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child {
  border-left-width: 1px;
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:rounded-r-md:last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.open\\:shadow-sm[open] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-within\\:relative:focus-within {
  position: relative;
}
.focus-within\\:z-20:focus-within {
  z-index: 20;
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#004C3F\\]\\/50:hover {
  border-color: rgb(0 76 63 / 0.5);
}
.hover\\:border-cyan-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}
.hover\\:border-cyan-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.hover\\:border-cyan-400\\/40:hover {
  border-color: rgb(34 211 238 / 0.4);
}
.hover\\:border-cyan-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.hover\\:border-cyan-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-900:hover {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}
.hover\\:bg-accent:hover {
  background-color: hsl(var(--accent));
}
.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(34 211 238 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-50\\/40:hover {
  background-color: rgb(236 254 255 / 0.4);
}
.hover\\:bg-cyan-50\\/60:hover {
  background-color: rgb(236 254 255 / 0.6);
}
.hover\\:bg-cyan-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-cyan-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-destructive\\/80:hover {
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover {
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-muted:hover {
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover {
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-orange-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary:hover {
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover {
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover {
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 113 133 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(190 18 60 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-rose-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(159 18 57 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-secondary:hover {
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover {
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50\\/60:hover {
  background-color: rgb(248 250 252 / 0.6);
}
.hover\\:bg-slate-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-800\\/40:hover {
  background-color: rgb(30 41 59 / 0.4);
}
.hover\\:bg-slate-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/40:hover {
  background-color: rgb(255 255 255 / 0.4);
}
.hover\\:bg-white\\/50:hover {
  background-color: rgb(255 255 255 / 0.5);
}
.hover\\:bg-white\\/60:hover {
  background-color: rgb(255 255 255 / 0.6);
}
.hover\\:bg-white\\/70:hover {
  background-color: rgb(255 255 255 / 0.7);
}
.hover\\:text-\\[\\#2E0B12\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(46 11 18 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover {
  color: hsl(var(--accent-foreground));
}
.hover\\:text-amber-900:hover {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.hover\\:text-amber-950:hover {
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-300:hover {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-400:hover {
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-600:hover {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-700:hover {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-800:hover {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-900:hover {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-600:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-800:hover {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.hover\\:text-emerald-900:hover {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-foreground:hover {
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover {
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover {
  color: hsl(var(--primary-foreground));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-900:hover {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-600:hover {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-800:hover {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-200:hover {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-violet-600:hover {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:ring-1:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-rose-400:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 113 133 / var(--tw-ring-opacity, 1));
}
.hover\\:ring-slate-200:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.hover\\:\\[animation-play-state\\:paused\\]:hover {
  animation-play-state: paused;
}
.focus\\:border-cyan-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}
.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-rose-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(251 113 133 / var(--tw-border-opacity, 1));
}
.focus\\:border-slate-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.focus\\:bg-accent:focus {
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus {
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus {
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus {
  color: hsl(var(--primary-foreground));
}
.focus\\:text-red-700:focus {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.focus\\:opacity-100:focus {
  opacity: 1;
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#4A0D18\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 13 24 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 243 252 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-cyan-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-ring:focus {
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-rose-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 113 133 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-white\\/50:focus {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible {
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible {
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible {
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:cursor-wait:disabled {
  cursor: wait;
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.group[open] .group-open\\:inline {
  display: inline;
}
.group[open] .group-open\\:hidden {
  display: none;
}
.group[open] .group-open\\:rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[open] .group-open\\:bg-\\[\\#4A0D18\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(74 13 24 / var(--tw-bg-opacity, 1));
}
.group[open] .group-open\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:underline {
  text-decoration-line: underline;
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40 {
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border {
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted {
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary {
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background {
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground {
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground {
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground {
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover {
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover {
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover {
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover {
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus {
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus {
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed {
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70 {
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled) {
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"] {
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"] {
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"] {
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled] {
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"] {
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"] {
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"] {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"] {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"] {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"] {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"] {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"] {
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"] {
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up {

  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"] {
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down {

  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"] {
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"] {
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"] {
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"] {
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"] {
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"] {
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"] {
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"] {
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder] {
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"] {
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"] {
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"] {
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"] {
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"] {
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled] {
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"] {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"] {
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"] {
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"] {
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"] {
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"] {
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"] {
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"] {
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"] {
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"] {
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"] {
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"] {
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"] {
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"] {
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"] {
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"] {
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"] {
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"] {
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"] {
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"] {
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"] {
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"] {
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"] {
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"] {
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"] {
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"] {
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"] {
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"] {
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"] {
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"] {
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"] {
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"] {
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"] {
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after {
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"] {
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"] {
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:divide-slate-700\\/60:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(51 65 85 / 0.6);
}
.dark\\:border-destructive:is(.dark *) {
  border-color: hsl(var(--destructive));
}
.dark\\:border-emerald-700\\/60:is(.dark *) {
  border-color: rgb(4 120 87 / 0.6);
}
.dark\\:border-emerald-700\\/80:is(.dark *) {
  border-color: rgb(4 120 87 / 0.8);
}
.dark\\:border-emerald-800\\/60:is(.dark *) {
  border-color: rgb(6 95 70 / 0.6);
}
.dark\\:border-red-900\\/60:is(.dark *) {
  border-color: rgb(127 29 29 / 0.6);
}
.dark\\:border-rose-900\\/60:is(.dark *) {
  border-color: rgb(136 19 55 / 0.6);
}
.dark\\:border-slate-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.dark\\:border-white\\/10:is(.dark *) {
  border-color: rgb(255 255 255 / 0.1);
}
.dark\\:border-white\\/15:is(.dark *) {
  border-color: rgb(255 255 255 / 0.15);
}
.dark\\:bg-\\[\\#1A0509\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 5 9 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#1A0509\\]\\/80:is(.dark *) {
  background-color: rgb(26 5 9 / 0.8);
}
.dark\\:bg-\\[\\#240710\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(36 7 16 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#3A0F19\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(58 15 25 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#FFFDF7\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 253 247 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-emerald-950\\/40:is(.dark *) {
  background-color: rgb(2 44 34 / 0.4);
}
.dark\\:bg-emerald-950\\/60:is(.dark *) {
  background-color: rgb(2 44 34 / 0.6);
}
.dark\\:bg-red-950\\/40:is(.dark *) {
  background-color: rgb(69 10 10 / 0.4);
}
.dark\\:bg-slate-800\\/40:is(.dark *) {
  background-color: rgb(30 41 59 / 0.4);
}
.dark\\:bg-slate-800\\/60:is(.dark *) {
  background-color: rgb(30 41 59 / 0.6);
}
.dark\\:bg-slate-900\\/40:is(.dark *) {
  background-color: rgb(15 23 42 / 0.4);
}
.dark\\:text-\\[\\#1A0509\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(26 5 9 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#FFFDF7\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 253 247 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-200\\/90:is(.dark *) {
  color: rgb(254 202 202 / 0.9);
}
.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-300\\/80:is(.dark *) {
  color: rgb(253 164 175 / 0.8);
}
.dark\\:text-rose-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.dark\\:opacity-\\[0\\.06\\]:is(.dark *) {
  opacity: 0.06;
}
.dark\\:placeholder\\:text-slate-500:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:border-white\\/20:hover:is(.dark *) {
  border-color: rgb(255 255 255 / 0.2);
}
.dark\\:hover\\:bg-white:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-white\\/10:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:hover\\:bg-white\\/\\[0\\.04\\]:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.04);
}
.dark\\:hover\\:text-black:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:bottom-24 {
    bottom: 6rem;
  }

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-6 {
    right: 1.5rem;
  }

  .sm\\:right-auto {
    right: auto;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:-m-6 {
    margin: -1.5rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:h-20 {
    height: 5rem;
  }

  .sm\\:w-\\[380px\\] {
    width: 380px;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[1fr_12rem\\] {
    grid-template-columns: 1fr 12rem;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg {
    border-radius: var(--radius);
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:pt-28 {
    padding-top: 7rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"] {
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:sticky {
    position: sticky;
  }

  .md\\:inset-x-auto {
    left: auto;
    right: auto;
  }

  .md\\:-left-40 {
    left: -10rem;
  }

  .md\\:-right-40 {
    right: -10rem;
  }

  .md\\:-top-40 {
    top: -10rem;
  }

  .md\\:bottom-6 {
    bottom: 1.5rem;
  }

  .md\\:left-auto {
    left: auto;
  }

  .md\\:right-4 {
    right: 1rem;
  }

  .md\\:right-6 {
    right: 1.5rem;
  }

  .md\\:top-24 {
    top: 6rem;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .md\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .md\\:ml-auto {
    margin-left: auto;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:h-56 {
    height: 14rem;
  }

  .md\\:h-\\[560px\\] {
    height: 560px;
  }

  .md\\:h-\\[720px\\] {
    height: 720px;
  }

  .md\\:w-20 {
    width: 5rem;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-56 {
    width: 14rem;
  }

  .md\\:w-\\[560px\\] {
    width: 560px;
  }

  .md\\:w-\\[640px\\] {
    width: 640px;
  }

  .md\\:w-\\[720px\\] {
    width: 720px;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\] {
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-\\[220px\\] {
    min-width: 220px;
  }

  .md\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .md\\:max-w-none {
    max-width: none;
  }

  .md\\:max-w-sm {
    max-width: 24rem;
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1\\.15fr\\2c 1fr\\] {
    grid-template-columns: 1.15fr 1fr;
  }

  .md\\:grid-cols-\\[1\\.15fr\\2c auto\\] {
    grid-template-columns: 1.15fr auto;
  }

  .md\\:grid-cols-\\[1fr_360px\\] {
    grid-template-columns: 1fr 360px;
  }

  .md\\:grid-cols-\\[1fr_auto\\] {
    grid-template-columns: 1fr auto;
  }

  .md\\:grid-cols-\\[220px_1fr\\] {
    grid-template-columns: 220px 1fr;
  }

  .md\\:grid-cols-\\[240px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 240px minmax(0,1fr);
  }

  .md\\:grid-cols-\\[64px_1fr_auto\\] {
    grid-template-columns: 64px 1fr auto;
  }

  .md\\:grid-cols-\\[auto\\2c 1fr\\] {
    grid-template-columns: auto 1fr;
  }

  .md\\:grid-cols-\\[auto_1fr_auto\\] {
    grid-template-columns: auto 1fr auto;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:rounded-2xl {
    border-radius: 1rem;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:pb-8 {
    padding-bottom: 2rem;
  }

  .md\\:pr-2 {
    padding-right: 0.5rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:top-24 {
    top: 6rem;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:inline-flex {
    display: inline-flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr\\2c 1\\.2fr\\] {
    grid-template-columns: 1fr 1.2fr;
  }

  .lg\\:grid-cols-\\[1fr_2fr\\] {
    grid-template-columns: 1fr 2fr;
  }

  .lg\\:grid-cols-\\[256px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 256px minmax(0,1fr);
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-8xl {
    font-size: 6rem;
    line-height: 1;
  }
}
@media (min-width: 1280px) {

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}
@media print {

  .print\\:hidden {
    display: none;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start) {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]) {
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]) {
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside) {
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]) {
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div {
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg {
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg {
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg {
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg {
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg {
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg {
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg {
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg {
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~* {
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr {
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading] {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading] {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading] {
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading] {
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group] {
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg {
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input] {
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item] {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item] {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg {
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg {
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg {
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg {
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child {
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr {
  border-bottom-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,wBAAc,UAAd,YAAc;IAAd,sBAAc,aAAd,YAAc;IAAd,kBAAc,iBAAd,YAAc;IAAd,2BAAc;IAAd,qBAAc;IAAd,8BAAc;IAAd,sBAAc,aAAd,YAAc;IAAd,iCAAc,EAAd,YAAc;IAAd,uBAAc,YAAd,YAAc;IAAd,mCAAc;IAAd,mBAAc;IAAd,6BAAc,MAAd,YAAc;IAAd,oBAAc,eAAd,YAAc;IAAd,6BAAc;IAAd,wBAAc,WAAd,YAAc;IAAd,qCAAc;IAAd,oBAAc,eAAd,YAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,iBAAc;EAAA;;EAAd;;IAAA,wBAAc,WAAd,YAAc;IAAd,yBAAc,UAAd,YAAc;IAAd,mBAAc,gBAAd,YAAc;IAAd,8BAAc;IAAd,sBAAc;IAAd,iCAAc;IAAd,qBAAc,cAAd,YAAc;IAAd,8BAAc;IAAd,wBAAc,WAAd,YAAc;IAAd,mCAAc;IAAd,oBAAc,eAAd,YAAc;IAAd,8BAAc,KAAd,YAAc;IAAd,oBAAc,eAAd,YAAc;IAAd,6BAAc;IAAd,wBAAc,WAAd,YAAc;IAAd,qCAAc;IAAd,qBAAc,cAAd,8BAAc;IAAd,oBAAc;IAAd,kBAAc;EAAA;EAAd,IAAA,gCAAc,EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA,wBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,kGAAkG;;AAIlG;;;;qEAIqE;AACrE;EACE,8CAA8C;EAC9C,4BAA4B,IAAI,0BAA0B;EAC1D,4BAA4B,IAAI,2CAA2C;EAC3E,4BAA4B,IAAI,8BAA8B;EAC9D,4BAA4B,IAAI,iCAAiC;EACjE,4BAA4B,IAAI,iBAAiB;EACjD,4BAA4B,IAAI,SAAS;EACzC,4BAA4B,IAAI,mBAAmB;EACnD,4BAA4B,IAAI,2BAA2B;EAC3D,gCAAgC,EAAE,sBAAsB;EACxD,4BAA4B,IAAI,4CAA4C;EAC5E,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B,IAAI,iBAAiB;EACjD,4BAA4B,IAAI,iBAAiB;EACjD,4BAA4B,IAAI,qBAAqB;EACrD,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,2CAA2C;;EAE3C,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,uEAAuE;EACvE,8BAA8B;EAC9B,mCAAmC;EACnC,yBAAyB;;EAEzB,yCAAyC;EACzC,oCAAoC;EACpC,kCAAkC;EAClC,wCAAwC;EACxC,oCAAoC;EACpC,kCAAkC;EAClC,8BAA8B;;EAE9B,gCAAgC;EAChC,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;;EAEvC,kEAAkE;EAClE,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;;EAExC,0DAA0D;EAC1D,mDAAmD;;EAEnD,gFAAgF;EAChF;;;qDAGmD;AACrD;;AAEA;;qEAEqE;AACrE;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,4CAA4C;EAC5C,6CAA6C;EAC7C,0BAA0B;;EAE1B,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;;EAE1B,0BAA0B;EAC1B,0BAA0B;EAC1B,mCAAmC;EACnC,yCAAyC;EACzC,2CAA2C;EAC3C,+BAA+B;;EAE/B,iCAAiC;EACjC,sCAAsC;EACtC,uCAAuC;EACvC,0BAA0B;;EAE1B,yCAAyC;EACzC,uCAAuC;EACvC,4CAA4C;;EAE5C,uDAAuD;EACvD,0DAA0D;;EAE1D;;;qDAGmD;AACrD;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE,6BAA6B,+BAA+B,EAAE;AAC9D,6BAA6B,+BAA+B,EAAE;AAC9D,6BAA6B,iCAAiC,EAAE;AAChE,6BAA6B,gCAAgC,EAAE;AAC/D,6BAA6B,kCAAkC,EAAE;AACjE,6BAA6B,0CAA0C,EAAE;AACzE;;;;;;;;;;;2BAW2B,mDAAmD,EAAE;AAChF;;;+BAG+B,kDAAkD,EAAE;AACnF,8DAA8D;AAC9D;;+BAE+B,kDAAkD,EAAE;AACnF;;;iCAGiC,kDAAkD,EAAE;AACrF;mCACmC,kDAAkD,EAAE;AACvF;;6DAE6D;AAC7D;;;;;;EAME,iCAAiC;EACjC,qDAAqD;EACrD,gDAAgD;AAClD;AACA,2BAA2B,mDAAmD,EAAE;AAChF,kDAAkD,kDAAkD,EAAE;AACtG;;EAEE,iCAAiC;EACjC,kCAAkC;EAClC,oBAAoB;AACtB;AACA;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,oBAAoB;AACtB;AACA;;EAEE,gCAAgC;AAClC;AACA;;EAEE,2CAA2C;AAC7C;;AAEA;;8CAE8C;AAC9C;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,kDAAkD;EAClD,kDAAkD;AACpD;AACA;;EAEE,wCAAwC;EACxC,uCAAuC;EACvC,oBAAoB;EACpB;;2CAEyC;AAC3C;AACA;EACE;;+BAE6B;EAC7B,uCAAuC;EACvC,oBAAoB;EACpB;;2CAEyC;AAC3C;AACA;EACE;;gCAE8B;EAC9B,sCAAsC;EACtC;;2CAEyC;AAC3C;AACA;;EAEE,uCAAuC;EACvC,uCAAuC;EACvC,oBAAoB;AACtB;AACA;;EAEE,wCAAwC;EACxC,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA,oCAAoC,mBAAmB,EAAE;AACzD;EACE,wCAAwC;EACxC,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;AACjC;AACA,mEAAmE;;AAEnE;+CAC+C;AAC/C;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;qDAEqD;AACrD,2CAA2C,gCAAgC,EAAE;AAC7E,iDAAiD,6BAA6B,EAAE;;AAEhF;2DAC2D;AAC3D;gCACgC,yBAAyB,EAAE;;AAE3D;;;+CAG+C;AAC/C;;;EAGE,qDAAqD;AACvD;AACA;;8EAE8E;AAC9E;;;;;;;;;;;EAWE,qDAAqD;AACvD;AACA;;;EAGE,qDAAqD;AACvD;AACA;;;EAGE,iDAAiD;AACnD;AACA;;;;;;;;EAQE,yBAAyB;AAC3B;AACA;iFACiF;AACjF;;;;;;EAME,yBAAyB;AAC3B;AACA,6DAA6D;AAC7D;;;2BAG2B,qDAAqD,EAAE;AAClF;;mCAEmC,gDAAgD,EAAE;AACrF;;6BAE6B,yBAAyB,EAAE;AACxD,oBAAoB;AACpB;4BAC4B,oDAAoD,EAAE;AAClF,6BAA6B,+CAA+C,EAAE;AAC9E;2BAC2B,yBAAyB,EAAE;AACtD,2BAA2B,yBAAyB,EAAE;AACtD,8CAA8C;AAC9C,0BAA0B,mDAAmD,EAAE;AAC/E,2BAA2B,mDAAmD,EAAE;AAChF;+BAC+B,kDAAkD,EAAE;AACnF;gCACgC,yBAAyB,EAAE;AAC3D,gCAAgC,yBAAyB,EAAE;AAC3D,SAAS;AACT;6BAC6B,qDAAqD,EAAE;AACpF,uDAAuD,yBAAyB,EAAE;AAClF;yEACyE;AACzE,6BAA6B,yBAAyB,EAAE;;AAExD,qGAAqG;AACrG;sBACsB,kDAAkD,EAAE;AAC1E;wBACwB,yBAAyB,EAAE;AACnD,4BAA4B,2CAA2C,EAAE;AACzE;;;;yBAIyB,kDAAkD,EAAE;AAC7E,2BAA2B,sDAAsD,EAAE;AACnF;;;yBAGyB,oDAAoD,EAAE;AAC/E;;;6BAG6B,qDAAqD,EAAE;AACpF;;8BAE8B,qDAAqD,EAAE;AACrF;8BAC8B,qDAAqD,EAAE;AACrF;;8BAE8B,+CAA+C,EAAE;AAC/E;;;iCAGiC,gDAAgD,EAAE;AACnF;;;;;;;;;gCASgC,yBAAyB,EAAE;AAC3D;;;2BAG2B,yBAAyB,EAAE;AACtD;8BAC8B,yBAAyB,EAAE;AACzD,yGAAyG;AACzG,4CAA4C,yBAAyB,EAAE;AACvE,sCAAsC,sCAAsC,EAAE;AAC9E,yEAAyE;AACzE;;;;sDAIsD,yBAAyB,EAAE;AACjF,uEAAuE;AACvE;EACE,iDAAiD;EACjD,yBAAyB;AAC3B;AACA,kCAAkC,qDAAqD,EAAE;AACzF,0DAA0D,cAAc,EAAE;AAC1E,gCAAgC,yBAAyB,EAAE;AAC3D,8BAA8B,yBAAyB,EAAE;AACzD,uHAAuH;AACvH;wCACwC,yBAAyB,EAAE;AACnE,gFAAgF;AAChF,mCAAmC,gCAAgC,EAAE;AACrE,wHAAwH;AACxH;;;;;;;;;uCASuC,sDAAsD,EAAE;;AAE/F;;qEAEqE;;AAiDrE,oBAAoB,YAAY,EAAE;;AAElC;EACE,SAAS;EACT,yFAAyF;EACzF,qBAAqB;EACrB,wBAAwB;EACxB,yCAAyC;EACzC,4BAA4B;EAC5B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,iDAAiD;EACjD,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;qEAEqE;AACrE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;AACA,aAAa,+EAA+E,EAAE;AAC9F,aAAa,kFAAkF,EAAE;AACjG,aAAa,iFAAiF,EAAE;AAChG,aAAa,+EAA+E,EAAE;;AAE9F;EACE,WAAW,mCAAmC,EAAE;EAChD,WAAW,6CAA6C,EAAE;EAC1D,WAAW,6CAA6C,EAAE;AAC5D;AACA,cAAc,8CAA8C,EAAE;;AAE9D;;qEAEqE;AACrE;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,0EAA0E;AAC5E;;AAEA;;;qEAGqE;AACrE;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C;;6CAE2C;AAC7C;AACA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kDAAkD;EAClD,2CAA2C;EAC3C;;;2CAGyC;AAC3C;AACA;EACE,2CAA2C;EAC3C,0CAA0C;EAC1C,kDAAkD;EAClD,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA;;;qEAGqE;AACrE;EACE;;mCAEiC;EACjC,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C,mBAAmB;EACnB;;;yCAGuC;EACvC;;;;yBAIuB;AACzB;AACA;EACE,2BAA2B;EAC3B;;mCAEiC;EACjC;;;yCAGuC;EACvC,oCAAoC;AACtC;;AAEA;;;;;qEAKqE;AACrE;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB;;2CAEyC;EACzC;;;yBAGuB;AACzB;AACA;EACE,kCAAkC;EAClC;;0CAEwC;AAC1C;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB;;2CAEyC;EACzC,oFAAoF;AACtF;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,0BAA0B,mCAAmC,EAAE,sBAAsB,EAAE;;AAEvF,sCAAsC;AACtC;EACE,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB;;;oBAGkB;AACpB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,gEAAgE;AAClE;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;;qEAGqE;AACrE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,4CAA4C;AAC9C;AACA,qDAAqD;AACrD,iBAAiB,qBAAqB;EACpC,8BAA8B;EAC9B,qCAAqC;EACrC,6BAA6B;AAC/B;AACA,iBAAiB,uBAAuB;EACtC,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA,iBAAiB,wCAAwC;EACvD,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;qEAEqE;AACrE;EACE,WAAW;EACX,mFAAmF;EACnF,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW,sCAAsC,EAAE;AACnD;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,WAAW,iCAAiC,EAAE;;AAE9C;EACE,WAAW,2BAA2B,EAAE;EACxC,WAAW,6BAA6B,EAAE;AAC5C;AACA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;;qEAEqE;AACrE;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kDAAkD;EAClD,wCAAwC;EACxC,qBAAqB;EACrB,mBAAmB;EACnB,uFAAuF;AACzF;AACA,yBAAyB,4BAA4B,EAAE;AACvD;EACE,aAAa;EACb,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;;qEAEqE;AACrE,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,4BAA4B,uBAAuB,EAAE;AACrD;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA,kCAAkC,iCAAiC,EAAE;;AAErE,gBAAgB,kCAAkC,EAAE;;AAEpD;;qEAEqE;AACrE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;GAMC;EACD,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,kDAAkD;EAClD,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,2BAA2B,EAAE;EACpC,OAAO,2BAA2B,EAAE;AACtC;AACA,eAAe,kBAAkB,EAAE,UAAU,EAAE;;AAE/C;;;;qEAIqE;AACrE;EACE,6DAA6D;EAC7D,2CAA2C;EAC3C,6BAA6B;EAC7B;;2CAEyC;EACzC,+EAA+E;AACjF;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB;;;2BAGyB;AAC3B;AACA;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,sBAAsB;AACxB;AACA,2DAA2D;AAC3D;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;AAC9C;AACA,yDAAyD;AACzD,8BAA8B,mBAAmB,EAAE;AACnD,sCAAsC,uBAAuB,EAAE;;AAE/D;EACE,6DAA6D;AAC/D;;AAMA,iEAAiE;AACjE;oEACoE,wBAAwB,EAAE;AAh8B9F;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,mBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA,QAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,iDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,0CAi8BA;EAj8BA,uDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,2BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,+EAi8BA;EAj8BA,mGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,6EAi8BA;EAj8BA,iGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0CAi8BA;EAj8BA,uDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,2GAi8BA;EAj8BA,yGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,8BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,2GAi8BA;EAj8BA,yGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,2GAi8BA;EAj8BA,yGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,8BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,2GAi8BA;EAj8BA,yGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,2GAi8BA;EAj8BA,yGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,+EAi8BA;EAj8BA,mGAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,yBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,yBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,gDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,iDAi8BA;EAj8BA;AAi8BA;AAj8BA;;EAAA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;AAAA;AAj8BA;EAAA;AAi8BA;AAj8BA;;EAAA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;AAAA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,0EAi8BA;EAj8BA,8FAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA,yBAi8BA;EAj8BA,2BAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,+BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA,yBAi8BA;EAj8BA,2BAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,+BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA,yBAi8BA;EAj8BA,2BAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,+BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,wBAi8BA;EAj8BA,yBAi8BA;EAj8BA,8BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,wBAi8BA;EAj8BA,yBAi8BA;EAj8BA,8BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,wBAi8BA;EAj8BA,yBAi8BA;EAj8BA,8BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA,yBAi8BA;EAj8BA,0BAi8BA;EAj8BA,wBAi8BA;EAj8BA,yBAi8BA;EAj8BA,8BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,0BAi8BA;EAj8BA,qBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,mBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;;EAAA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,uBAi8BA;IAj8BA,sDAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,uBAi8BA;IAj8BA,oDAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,uBAi8BA;IAj8BA,2DAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,oBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,eAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA;EAi8BA;AAAA;AAj8BA;;EAAA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,UAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,iBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,iBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,eAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,iBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;AAAA;AAj8BA;;EAAA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA;EAi8BA;;EAj8BA;IAAA,mBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,kBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,iBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,eAi8BA;IAj8BA;EAi8BA;AAAA;AAj8BA;;EAAA;IAAA;EAi8BA;;EAj8BA;IAAA,iBAi8BA;IAj8BA;EAi8BA;;EAj8BA;IAAA,eAi8BA;IAj8BA;EAi8BA;AAAA;AAj8BA;;EAAA;IAAA;EAi8BA;AAAA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,iDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,iDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kDAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,gBAi8BA;EAj8BA,oBAi8BA;EAj8BA,4BAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,sBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,WAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,mBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,qBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,kBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA,oBAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA,WAi8BA;EAj8BA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA;AAj8BA;EAAA;AAi8BA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Fonts: Cormorant Garamond for editorial display, General Sans for UI, JetBrains Mono for data */\n@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,500;0,600;0,700;1,400&family=Inter+Tight:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap\");\n@import url(\"https://api.fontshare.com/v2/css?f[]=general-sans@400,500,600,700&display=swap\");\n\n/* ================================================================\n   CYANNECT · Premium Burgundy + Cream Design Tokens (iter 61)\n   60% cream/ivory · 25% burgundy · 10% ink · 5% green accent\n   All --pf-* aliases retained so existing component classes work.\n   ================================================================ */\n:root {\n  /* ---- Primary palette (spec §PRIMARY) ---- */\n  --cy-burgundy:       #4A0D18;   /* Primary dark burgundy */\n  --cy-burgundy-dark:  #2E0B12;   /* Deep burgundy — depth surfaces, footer */\n  --cy-bg:             #F4F1E8;   /* Warm cream — main page bg */\n  --cy-surface:        #FAF8F2;   /* Soft ivory — cards, elevated */\n  --cy-text:           #1A1A1A;   /* Primary text */\n  --cy-text-body:      #3F3D39;   /* Body */\n  --cy-text-muted:     #66625D;   /* Secondary text */\n  --cy-text-on-dark:   #FFFDF7;   /* Cream text on burgundy */\n  --cy-text-on-dark-muted: #D8C8C5; /* Muted on burgundy */\n  --cy-accent:         #A8D85D;   /* Cyannect accent green — actions/rewards */\n  --cy-accent-hover:   #B7E66B;\n  --cy-accent-active:  #94C64F;\n  --cy-border:         #DED9CF;   /* Light border */\n  --cy-border-strong:  #CEC8BE;   /* Input border */\n  --cy-muted-bg:       #EBE7DE;   /* Muted section bg */\n  --cy-success:        #2F7D4A;\n  --cy-error:          #B42318;\n  --cy-warning:        #B7791F;\n  --cy-placeholder:    #8A857D;\n  --cy-focus-ring:     rgba(74, 13, 24, 0.15);\n\n  /* Supporting chart palette (spec §15) */\n  --cy-chart-burgundy: #4A0D18;\n  --cy-chart-green:    #A8D85D;\n  --cy-chart-mburg:    #8A4550;\n  --cy-chart-gold:     #D6A84B;\n  --cy-chart-gray:     #AAA39A;\n  --cy-chart-dark:     #2E0B12;\n\n  /* ---- Legacy --pf-* aliases (unchanged names, remapped values) ---- */\n  --pf-bg:          var(--cy-bg);\n  --pf-bg-2:        var(--cy-surface);\n  --pf-bg-3:        #FFFFFF;\n\n  --pf-forest-dark: var(--cy-burgundy-dark);\n  --pf-forest:      var(--cy-burgundy);\n  --pf-green:       var(--cy-accent);\n  --pf-green-2:     var(--cy-accent-hover);\n  --pf-sage:        var(--cy-muted-bg);\n  --pf-mint:        var(--cy-accent);\n  --pf-cream:       var(--cy-bg);\n\n  --pf-ink:         var(--cy-text);\n  --pf-ink-2:       var(--cy-text-body);\n  --pf-mute:        var(--cy-text-muted);\n  --pf-mute-2:      var(--cy-placeholder);\n\n  /* Glass surface system — subtle so cards keep a warm cream feel */\n  --pf-glass:       rgba(255, 253, 247, 0.88);\n  --pf-glass-2:     rgba(244, 241, 232, 0.72);\n  --pf-glass-line:  rgba(74, 13, 24, 0.12);\n\n  --pf-shadow:      0 20px 50px -15px rgba(46, 11, 18, 0.10);\n  --pf-shadow-sm:   0 4px 20px rgba(46, 11, 18, 0.06);\n\n  --pf-gradient:    linear-gradient(135deg, #2E0B12 0%, #4A0D18 60%, #5C1422 100%);\n  --pf-gradient-hero:\n    radial-gradient(70% 60% at 20% 15%, rgba(74, 13, 24, 0.04), transparent 65%),\n    radial-gradient(60% 50% at 80% 85%, rgba(235, 231, 222, 0.6), transparent 70%),\n    linear-gradient(180deg, #F4F1E8 0%, #FAF8F2 100%);\n}\n\n/* ================================================================\n   Dark mode (Deep Burgundy Night)\n   ================================================================ */\n:root.dark {\n  --cy-bg:           #1A0509;\n  --cy-surface:      #2E0B12;\n  --cy-text:         #FFFDF7;\n  --cy-text-body:    #E9DFD8;\n  --cy-text-muted:   #B5A8A3;\n  --cy-border:       rgba(255, 253, 247, 0.14);\n  --cy-border-strong: rgba(255, 253, 247, 0.22);\n  --cy-muted-bg:     #3A0F19;\n\n  --pf-bg:           var(--cy-bg);\n  --pf-bg-2:         var(--cy-surface);\n  --pf-bg-3:         #240710;\n\n  --pf-forest-dark:  #150408;\n  --pf-forest:       #5C1422;\n  --pf-green:        var(--cy-accent);\n  --pf-green-2:      var(--cy-accent-hover);\n  --pf-sage:         rgba(168, 216, 93, 0.15);\n  --pf-cream:        var(--cy-bg);\n\n  --pf-ink:          var(--cy-text);\n  --pf-ink-2:        var(--cy-text-body);\n  --pf-mute:         var(--cy-text-muted);\n  --pf-mute-2:       #7E6E6A;\n\n  --pf-glass:        rgba(46, 11, 18, 0.82);\n  --pf-glass-2:      rgba(26, 5, 9, 0.65);\n  --pf-glass-line:   rgba(255, 253, 247, 0.15);\n\n  --pf-shadow:       0 20px 60px -20px rgba(0, 0, 0, 0.6);\n  --pf-shadow-sm:    0 8px 24px -12px rgba(74, 13, 24, 0.35);\n\n  --pf-gradient-hero:\n    radial-gradient(60% 55% at 15% 20%, rgba(92, 20, 34, 0.35), transparent 60%),\n    radial-gradient(55% 55% at 85% 15%, rgba(46, 11, 18, 0.6), transparent 60%),\n    linear-gradient(180deg, #1A0509 0%, #240710 100%);\n}\n\n:root.dark,\n:root.dark body {\n  background: var(--pf-bg);\n  color: var(--pf-ink);\n  color-scheme: dark;\n}\n\n/* Dark mode text/bg fallbacks (Tailwind slate-* → burgundy palette) */\n:root.dark .text-slate-900 { color: var(--pf-ink) !important; }\n:root.dark .text-slate-800 { color: var(--pf-ink) !important; }\n:root.dark .text-slate-700 { color: var(--pf-ink-2) !important; }\n:root.dark .text-slate-600 { color: var(--pf-mute) !important; }\n:root.dark .text-slate-500 { color: var(--pf-mute-2) !important; }\n:root.dark .text-slate-400 { color: rgba(216, 200, 197, 0.7) !important; }\n:root.dark .bg-white,\n:root.dark .bg-white\\/95,\n:root.dark .bg-white\\/90,\n:root.dark .bg-white\\/85,\n:root.dark .bg-white\\/80,\n:root.dark .bg-white\\/70,\n:root.dark .bg-white\\/60,\n:root.dark .bg-white\\/50,\n:root.dark .bg-white\\/40,\n:root.dark .bg-white\\/30,\n:root.dark .bg-white\\/20,\n:root.dark .bg-white\\/10 { background-color: rgba(46, 11, 18, 0.75) !important; }\n:root.dark .border-white\\/80,\n:root.dark .border-white\\/70,\n:root.dark .border-white\\/60,\n:root.dark .border-white\\/50 { border-color: rgba(255, 253, 247, 0.15) !important; }\n/* iter66 · slate borders/dividers → cream hairlines on dark */\n:root.dark .border-slate-100,\n:root.dark .border-slate-200,\n:root.dark .border-slate-300 { border-color: rgba(255, 253, 247, 0.12) !important; }\n:root.dark .border-t-slate-100,\n:root.dark .border-t-slate-200,\n:root.dark .border-b-slate-100,\n:root.dark .border-b-slate-200 { border-color: rgba(255, 253, 247, 0.12) !important; }\n:root.dark .divide-slate-100 > *,\n:root.dark .divide-slate-200 > * { border-color: rgba(255, 253, 247, 0.10) !important; }\n/* iter66 · Tailwind linear-gradient tokens that combine light cyan/emerald/violet\n   into pastel pill backgrounds — force to a subtle accent-green fill so the\n   uppercase stat text and icon inside stay legible on dark */\n:root.dark [class*=\"from-cyan-50\"][class*=\"to-emerald-50\"],\n:root.dark [class*=\"from-cyan-50\"][class*=\"to-violet-50\"],\n:root.dark [class*=\"from-emerald-50\"][class*=\"to-cyan-50\"],\n:root.dark [class*=\"from-emerald-50\"][class*=\"to-violet-50\"],\n:root.dark [class*=\"from-violet-50\"][class*=\"to-cyan-50\"],\n:root.dark [class*=\"from-violet-50\"][class*=\"to-emerald-50\"] {\n  background-image: none !important;\n  background-color: rgba(168, 216, 93, 0.18) !important;\n  border-color: rgba(168, 216, 93, 0.4) !important;\n}\n:root.dark .bg-slate-100 { background-color: rgba(46, 11, 18, 0.65) !important; }\n:root.dark hr, :root.dark .divide-slate-200 > * { border-color: rgba(255, 253, 247, 0.15) !important; }\n:root.dark .glass-strong,\n:root.dark .pf-card {\n  background-color: var(--pf-glass);\n  border-color: var(--pf-glass-line);\n  color: var(--pf-ink);\n}\n:root.dark .pf-input,\n:root.dark input, :root.dark textarea, :root.dark select {\n  background-color: rgba(26, 5, 9, 0.8);\n  border-color: rgba(255, 253, 247, 0.18);\n  color: var(--pf-ink);\n}\n:root.dark .pf-input::placeholder,\n:root.dark input::placeholder, :root.dark textarea::placeholder {\n  color: rgba(216, 200, 197, 0.55);\n}\n:root.dark thead,\n:root.dark .uppercase.tracking-widest:not([class*=\"bg-\"]):not([class*=\"pf-btn\"]) {\n  color: rgba(216, 200, 197, 0.75) !important;\n}\n\n/* Dark mode — surface + text-on-surface overrides for named component classes\n   that don't use plain Tailwind utilities. Fixes header + hero + card\n   legibility flagged by the user in iter64. */\n:root.dark .glass-nav {\n  background-color: rgba(26, 5, 9, 0.82);\n  backdrop-filter: blur(24px) saturate(160%);\n  -webkit-backdrop-filter: blur(24px) saturate(160%);\n  border-bottom: 1px solid rgba(255, 253, 247, 0.10);\n}\n:root.dark .glass,\n:root.dark .glass-strong {\n  background-color: rgba(46, 11, 18, 0.72);\n  border-color: rgba(255, 253, 247, 0.12);\n  color: var(--pf-ink);\n  box-shadow:\n    0 20px 60px -20px rgba(0, 0, 0, 0.6),\n    inset 0 1px 0 rgba(255, 253, 247, 0.06);\n}\n:root.dark .pf-card {\n  background: linear-gradient(180deg,\n    rgba(46, 11, 18, 0.85) 0%,\n    rgba(36, 7, 16, 0.75) 100%);\n  border-color: rgba(255, 253, 247, 0.12);\n  color: var(--pf-ink);\n  box-shadow:\n    0 12px 32px -12px rgba(0, 0, 0, 0.55),\n    inset 0 1px 0 rgba(255, 253, 247, 0.06);\n}\n:root.dark .pf-card:hover {\n  background: linear-gradient(180deg,\n    rgba(60, 14, 24, 0.9) 0%,\n    rgba(46, 11, 18, 0.82) 100%);\n  border-color: rgba(168, 216, 93, 0.32);\n  box-shadow:\n    0 20px 50px -12px rgba(0, 0, 0, 0.7),\n    inset 0 1px 0 rgba(255, 253, 247, 0.10);\n}\n:root.dark .pf-btn-glass,\n:root.dark .pf-btn-secondary {\n  background-color: rgba(46, 11, 18, 0.6);\n  border-color: rgba(255, 253, 247, 0.18);\n  color: var(--pf-ink);\n}\n:root.dark .pf-btn-glass:hover,\n:root.dark .pf-btn-secondary:hover {\n  background-color: rgba(74, 13, 24, 0.75);\n  border-color: var(--cy-accent);\n  color: var(--cy-accent);\n}\n:root.dark .pf-btn-burgundy {\n  background: #5C1422;\n  border-color: rgba(255, 253, 247, 0.18);\n}\n:root.dark .pf-btn-burgundy:hover { background: #6D1729; }\n:root.dark .pf-chip {\n  background-color: rgba(46, 11, 18, 0.75);\n  border-color: rgba(255, 253, 247, 0.12);\n  color: rgba(233, 223, 216, 0.9);\n}\n:root.dark .pf-chip-cyan {\n  background: rgba(168, 216, 93, 0.14);\n  border-color: rgba(168, 216, 93, 0.4);\n  color: #C4E68A;\n}\n:root.dark .pf-chip-lav {\n  background: rgba(46, 11, 18, 0.75);\n  border-color: rgba(255, 253, 247, 0.12);\n  color: rgba(233, 223, 216, 0.9);\n}\n/* pf-chip-mint (green) stays green — high contrast on dark works */\n\n/* Hero display gradient — swap dark→dark for light→green so display headings\n   stay legible on a dark burgundy background */\n:root.dark .pf-gradient-text {\n  background: linear-gradient(135deg, #FFFDF7 0%, #E9DFD8 50%, #C4E68A 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n:root.dark .pf-gradient-text-2 {\n  background: linear-gradient(135deg, #FFFDF7 0%, #A8D85D 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n/* Nav-specific link hover: our `text-slate-900` hover override handles it,\n   but idle text uses `text-slate-600` which we already remap to muted-cream.\n   Make hover crisp so links \"come alive\" on hover. */\n:root.dark [data-testid=\"site-navbar\"] a { color: rgba(233, 223, 216, 0.85); }\n:root.dark [data-testid=\"site-navbar\"] a:hover { color: var(--cy-text-on-dark); }\n\n/* Coupon card discount label (solid burgundy in light) needs a bright red-cream\n   in dark to stay legible against the dark burgundy card */\n:root.dark [style*=\"rgb(74, 13, 24)\"],\n:root.dark [style*=\"#4A0D18\"] { color: #F4B8C0 !important; }\n\n/* iter65 · Legacy Tailwind color-tinted chips/badges (About.js, feature cards,\n   etc.) that use direct bg-cyan-50/text-cyan-700 etc. — remap all cyan/mint/\n   violet light-tint utilities to the warm-cream + green-accent palette so they\n   stay legible on dark burgundy backgrounds. */\n:root.dark .bg-cyan-50,\n:root.dark .bg-emerald-50,\n:root.dark .bg-violet-50 {\n  background-color: rgba(168, 216, 93, 0.14) !important;\n}\n/* iter68 · opacity-variant background washes (used by ShoppersLanding Section\n   `tone=\"mint\"` wrapper via `bg-emerald-50/40`) — remap to a very faint accent\n   tint so alternating page bands don't wash out cream text on dark burgundy */\n:root.dark .bg-cyan-50\\/40,\n:root.dark .bg-cyan-50\\/50,\n:root.dark .bg-cyan-50\\/60,\n:root.dark .bg-cyan-50\\/70,\n:root.dark .bg-emerald-50\\/30,\n:root.dark .bg-emerald-50\\/40,\n:root.dark .bg-emerald-50\\/50,\n:root.dark .bg-emerald-50\\/60,\n:root.dark .bg-emerald-50\\/70,\n:root.dark .bg-violet-50\\/40,\n:root.dark .bg-violet-50\\/50 {\n  background-color: rgba(168, 216, 93, 0.05) !important;\n}\n:root.dark .bg-cyan-100,\n:root.dark .bg-emerald-100,\n:root.dark .bg-violet-100 {\n  background-color: rgba(168, 216, 93, 0.20) !important;\n}\n:root.dark .border-cyan-200,\n:root.dark .border-emerald-200,\n:root.dark .border-violet-200 {\n  border-color: rgba(168, 216, 93, 0.35) !important;\n}\n:root.dark .text-cyan-700,\n:root.dark .text-cyan-600,\n:root.dark .text-cyan-300,\n:root.dark .text-emerald-700,\n:root.dark .text-emerald-600,\n:root.dark .text-emerald-800,\n:root.dark .text-violet-700,\n:root.dark .text-violet-600 {\n  color: #C4E68A !important;\n}\n/* Beat the earlier `:root.dark .uppercase.tracking-widest` rule (3 classes)\n   with a 3-class combined selector so tinted uppercase chips also render green */\n:root.dark .uppercase.tracking-widest.text-cyan-700,\n:root.dark .uppercase.tracking-widest.text-emerald-700,\n:root.dark .uppercase.tracking-widest.text-violet-700,\n:root.dark .uppercase.tracking-widest.text-cyan-600,\n:root.dark .uppercase.tracking-widest.text-emerald-600,\n:root.dark .uppercase.tracking-widest.text-violet-600 {\n  color: #C4E68A !important;\n}\n/* Muted amber / cream tinted surfaces (warnings, callouts) */\n:root.dark .bg-amber-50,\n:root.dark .bg-amber-50\\/70,\n:root.dark .bg-amber-50\\/50,\n:root.dark .bg-amber-100 { background-color: rgba(183, 121, 31, 0.15) !important; }\n:root.dark .border-amber-200,\n:root.dark .border-amber-200\\/60,\n:root.dark .border-amber-200\\/40 { border-color: rgba(183, 121, 31, 0.4) !important; }\n:root.dark .text-amber-800,\n:root.dark .text-amber-700,\n:root.dark .text-amber-600 { color: #F0C876 !important; }\n/* Red danger tint */\n:root.dark .bg-red-50,\n:root.dark .bg-red-50\\/70 { background-color: rgba(180, 35, 24, 0.18) !important; }\n:root.dark .border-red-200 { border-color: rgba(180, 35, 24, 0.4) !important; }\n:root.dark .text-red-700,\n:root.dark .text-red-600 { color: #F4B8C0 !important; }\n:root.dark .text-red-800 { color: #FCA5A5 !important; }\n/* Cream & warm ivory surface dark overrides */\n:root.dark .bg-cream-50 { background-color: rgba(46, 11, 18, 0.75) !important; }\n:root.dark .bg-cream-100 { background-color: rgba(58, 15, 25, 0.85) !important; }\n:root.dark .border-cream-200,\n:root.dark .border-cream-300 { border-color: rgba(255, 253, 247, 0.14) !important; }\n:root.dark .text-burgundy-600,\n:root.dark .text-burgundy-700 { color: #F4B8C0 !important; }\n:root.dark .text-burgundy-800 { color: #F8D0D6 !important; }\n/* Blue */\n:root.dark .bg-blue-50,\n:root.dark .bg-blue-50\\/70 { background-color: rgba(168, 216, 93, 0.12) !important; }\n:root.dark .text-blue-700, :root.dark .text-blue-600 { color: #C4E68A !important; }\n/* Brighten `text-slate-500` muted labels on dark burgundy so shopper page\n   captions ('Running Shoes', 'Selected Jackets', etc.) don't disappear */\n:root.dark .text-slate-500 { color: #C7B5B0 !important; }\n\n/* 2026-11 · dark-mode tables + remaining light tints (user report: table columns/index unreadable) */\n:root.dark thead,\n:root.dark thead tr { background-color: rgba(58, 15, 25, 0.7) !important; }\n:root.dark thead th,\n:root.dark thead th * { color: #E9DFD8 !important; }\n:root.dark tbody tr:hover { background-color: rgba(255, 253, 247, 0.04); }\n:root.dark .bg-slate-50,\n:root.dark .bg-slate-50\\/40,\n:root.dark .bg-slate-50\\/50,\n:root.dark .bg-slate-50\\/60,\n:root.dark .bg-gray-50 { background-color: rgba(58, 15, 25, 0.6) !important; }\n:root.dark .bg-slate-200 { background-color: rgba(255, 253, 247, 0.10) !important; }\n:root.dark .bg-rose-50,\n:root.dark .bg-rose-50\\/40,\n:root.dark .bg-rose-100,\n:root.dark .bg-red-100 { background-color: rgba(180, 35, 24, 0.18) !important; }\n:root.dark .bg-sky-50,\n:root.dark .bg-indigo-50,\n:root.dark .bg-purple-50,\n:root.dark .bg-cyan-50\\/40 { background-color: rgba(168, 216, 93, 0.10) !important; }\n:root.dark .bg-orange-50,\n:root.dark .bg-amber-50\\/40,\n:root.dark .bg-amber-50\\/60 { background-color: rgba(183, 121, 31, 0.15) !important; }\n:root.dark .bg-emerald-200\\/40,\n:root.dark .bg-cyan-200\\/40 { background-color: rgba(168, 216, 93, 0.16) !important; }\n:root.dark .border-rose-200,\n:root.dark .border-red-100,\n:root.dark .border-rose-100 { border-color: rgba(180, 35, 24, 0.4) !important; }\n:root.dark .border-sky-200,\n:root.dark .border-indigo-200,\n:root.dark .border-cyan-100,\n:root.dark .border-emerald-100 { border-color: rgba(168, 216, 93, 0.3) !important; }\n:root.dark .text-cyan-800,\n:root.dark .text-cyan-900,\n:root.dark .text-cyan-950,\n:root.dark .text-emerald-900,\n:root.dark .text-sky-700,\n:root.dark .text-sky-800,\n:root.dark .text-indigo-700,\n:root.dark .text-teal-700,\n:root.dark .text-green-700,\n:root.dark .text-\\[\\#004C3F\\] { color: #C4E68A !important; }\n:root.dark .text-rose-600,\n:root.dark .text-rose-700,\n:root.dark .text-rose-800,\n:root.dark .text-red-900 { color: #F4B8C0 !important; }\n:root.dark .text-amber-900,\n:root.dark .text-orange-700 { color: #F0C876 !important; }\n/* Selected filter pills use bg-foreground (cream in dark) — keep their label dark so it stays readable */\n:root.dark .bg-foreground.text-background { color: #1A0509 !important; }\n:root.dark .pf-btn-primary:disabled { color: var(--cy-text-muted) !important; }\n/* Dark ink on bright fills (amber/lime/emerald buttons) must stay dark */\n:root.dark [class*=\"bg-amber-400\"].text-slate-900,\n:root.dark [class*=\"bg-amber-500\"].text-slate-900,\n:root.dark [class*=\"bg-yellow-400\"].text-slate-900,\n:root.dark [class*=\"bg-lime-400\"].text-slate-900,\n:root.dark [class*=\"bg-emerald-400\"].text-slate-900 { color: #1A1A1A !important; }\n/* Sidebar \"New / Preview\" badge on the active (green) admin nav link */\n:root.dark aside a.pf-btn-primary[aria-current=\"page\"] [data-testid$=\"-badge\"] {\n  background-color: rgba(26, 5, 9, 0.18) !important;\n  color: #1A1A1A !important;\n}\n:root.dark .bg-\\[\\#E3F5EC\\]\\/70 { background-color: rgba(168, 216, 93, 0.12) !important; }\n:root.dark [data-testid=\"site-navbar\"] a.pf-btn-primary { color: #1A1A1A; }\n:root.dark .text-\\[\\#4A0D18\\] { color: #F4B8C0 !important; }\n:root.dark .text-orange-800 { color: #F0C876 !important; }\n/* White labels on bright cyan/emerald pills (selected filters, \"Most popular\") — dark ink reads better on dark pages */\n:root.dark .bg-cyan-500.text-white,\n:root.dark .bg-emerald-500.text-white { color: #1A0509 !important; }\n/* Form fields flagged with a mistake keep a visible red outline on dark pages */\n:root.dark [aria-invalid=\"true\"] { border-color: #F4B8C0 !important; }\n/* Light hover tints (hover:bg-white*, hover:bg-slate-50/100) would flash a pale box under light text — keep them dark */\n:root.dark .hover\\:bg-white:hover,\n:root.dark .hover\\:bg-white\\/80:hover,\n:root.dark .hover\\:bg-white\\/70:hover,\n:root.dark .hover\\:bg-white\\/60:hover,\n:root.dark .hover\\:bg-white\\/50:hover,\n:root.dark .hover\\:bg-white\\/40:hover,\n:root.dark .hover\\:bg-slate-50:hover,\n:root.dark .hover\\:bg-slate-100:hover,\n:root.dark .hover\\:bg-gray-50:hover,\n:root.dark .hover\\:bg-gray-100:hover { background-color: rgba(255, 253, 247, 0.07) !important; }\n\n/* ================================================================\n   Shadcn base variables map\n   ================================================================ */\n@layer base {\n  :root {\n    --background: 42 33% 93%;         /* #F4F1E8 */\n    --foreground: 0 0% 10%;            /* #1A1A1A */\n    --card: 42 40% 97%;                /* #FAF8F2 */\n    --card-foreground: 0 0% 10%;\n    --popover: 42 40% 97%;\n    --popover-foreground: 0 0% 10%;\n    --primary: 349 71% 17%;            /* #4A0D18 */\n    --primary-foreground: 42 100% 98%; /* #FFFDF7 */\n    --secondary: 42 25% 89%;           /* #EBE7DE */\n    --secondary-foreground: 349 71% 17%;\n    --muted: 42 25% 89%;\n    --muted-foreground: 30 5% 38%;     /* #66625D */\n    --accent: 82 60% 61%;              /* #A8D85D */\n    --accent-foreground: 0 0% 10%;\n    --destructive: 4 79% 40%;          /* #B42318 */\n    --destructive-foreground: 42 100% 98%;\n    --border: 40 17% 84%;              /* #DED9CF */\n    --input: 40 17% 84%;\n    --ring: 349 71% 17%;\n    --radius: 0.75rem;\n  }\n\n  :root.dark,\n  .dark {\n    --background: 349 71% 7%;          /* #1A0509 */\n    --foreground: 42 100% 98%;         /* #FFFDF7 */\n    --card: 349 61% 12%;               /* #2E0B12 */\n    --card-foreground: 42 100% 98%;\n    --popover: 349 61% 12%;\n    --popover-foreground: 42 100% 98%;\n    --primary: 82 60% 61%;             /* #A8D85D */\n    --primary-foreground: 0 0% 10%;\n    --secondary: 349 46% 16%;          /* #3A0F19 */\n    --secondary-foreground: 42 100% 98%;\n    --muted: 349 46% 16%;              /* #3A0F19 */\n    --muted-foreground: 17 11% 68%;    /* #B5A8A3 */\n    --accent: 82 60% 61%;              /* #A8D85D */\n    --accent-foreground: 0 0% 10%;\n    --destructive: 4 79% 40%;          /* #B42318 */\n    --destructive-foreground: 42 100% 98%;\n    --border: 349 30% 20%;             /* rgba(255, 253, 247, 0.14) */\n    --input: 349 30% 20%;\n    --ring: 82 60% 61%;\n  }\n}\n\nhtml, body, #root { height: 100%; }\n\nbody {\n  margin: 0;\n  font-family: \"General Sans\", \"Inter Tight\", -apple-system, BlinkMacSystemFont, sans-serif;\n  color: var(--cy-text);\n  background: var(--cy-bg);\n  background-image: var(--pf-gradient-hero);\n  background-attachment: fixed;\n  -webkit-font-smoothing: antialiased;\n  color-scheme: light;\n}\n\n/* Editorial serif heading option for marketing display */\n.font-serif-display {\n  font-family: \"Cormorant Garamond\", Georgia, serif;\n  letter-spacing: -0.015em;\n  font-weight: 600;\n}\n\nh1, h2, h3, h4, .font-display {\n  font-family: \"General Sans\", sans-serif;\n  letter-spacing: -0.025em;\n  font-weight: 600;\n  color: var(--cy-text);\n}\n\n.font-mono {\n  font-family: \"JetBrains Mono\", monospace;\n  letter-spacing: -0.02em;\n}\n\n::selection {\n  background: var(--cy-burgundy);\n  color: var(--cy-text-on-dark);\n}\n\n/* ================================================================\n   Decorative background blobs — richer for the glass effect\n   ================================================================ */\n.blob {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  opacity: 0.55;\n  pointer-events: none;\n  z-index: 0;\n}\n.blob-cyan { background: radial-gradient(circle, rgba(74, 13, 24, 0.55) 0%, transparent 70%); }\n.blob-mint { background: radial-gradient(circle, rgba(235, 231, 222, 0.95) 0%, transparent 70%); }\n.blob-lav  { background: radial-gradient(circle, rgba(168, 216, 93, 0.45) 0%, transparent 70%); }\n.blob-rose { background: radial-gradient(circle, rgba(92, 20, 34, 0.50) 0%, transparent 70%); }\n\n@keyframes blob-float {\n  0%, 100% { transform: translate(0, 0) scale(1); }\n  33%      { transform: translate(24px, -30px) scale(1.08); }\n  66%      { transform: translate(-24px, 16px) scale(0.96); }\n}\n.blob-float { animation: blob-float 20s ease-in-out infinite; }\n\n/* ================================================================\n   Gradient text — used sparingly for hero accents\n   ================================================================ */\n.pf-gradient-text {\n  background: linear-gradient(135deg, #2E0B12 0%, #4A0D18 50%, #6B1526 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n}\n.pf-gradient-text-2 {\n  background: linear-gradient(135deg, #4A0D18 0%, #A8D85D 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n.pf-gradient-bg {\n  background: linear-gradient(135deg, #2E0B12 0%, #4A0D18 60%, #5C1422 100%);\n}\n\n/* ================================================================\n   Glass surfaces (iter62) — genuine frosted-glass morphism\n   Translucent cream + heavy backdrop blur + burgundy border tint\n   ================================================================ */\n.glass {\n  background-color: rgba(255, 253, 247, 0.55);\n  backdrop-filter: blur(24px) saturate(180%);\n  -webkit-backdrop-filter: blur(24px) saturate(180%);\n  border: 1px solid rgba(255, 253, 247, 0.7);\n  box-shadow:\n    0 8px 32px -8px rgba(46, 11, 18, 0.12),\n    inset 0 1px 0 0 rgba(255, 255, 255, 0.85);\n}\n.glass-strong {\n  background-color: rgba(250, 248, 242, 0.72);\n  backdrop-filter: blur(32px) saturate(200%);\n  -webkit-backdrop-filter: blur(32px) saturate(200%);\n  border: 1px solid rgba(255, 253, 247, 0.85);\n  box-shadow:\n    0 20px 50px -15px rgba(46, 11, 18, 0.18),\n    inset 0 1px 0 0 rgba(255, 255, 255, 1),\n    inset 0 -1px 0 0 rgba(74, 13, 24, 0.04);\n}\n.glass-nav {\n  background-color: rgba(244, 241, 232, 0.65);\n  backdrop-filter: blur(28px) saturate(180%);\n  -webkit-backdrop-filter: blur(28px) saturate(180%);\n  border-bottom: 1px solid rgba(255, 253, 247, 0.7);\n  box-shadow: 0 4px 20px -8px rgba(46, 11, 18, 0.05);\n}\n\n/* ================================================================\n   Cards (§6 + glass upgrade) — translucent ivory frost with\n   burgundy-tinted border + hover lift\n   ================================================================ */\n.pf-card {\n  background: linear-gradient(180deg,\n    rgba(255, 253, 247, 0.72) 0%,\n    rgba(250, 248, 242, 0.58) 100%);\n  backdrop-filter: blur(24px) saturate(160%);\n  -webkit-backdrop-filter: blur(24px) saturate(160%);\n  border: 1px solid rgba(255, 253, 247, 0.9);\n  border-radius: 16px;\n  box-shadow:\n    0 6px 24px -8px rgba(46, 11, 18, 0.10),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9),\n    inset 0 -1px 0 rgba(74, 13, 24, 0.03);\n  transition:\n    transform 260ms ease,\n    box-shadow 260ms ease,\n    border-color 260ms ease,\n    background 260ms ease;\n}\n.pf-card:hover {\n  transform: translateY(-2px);\n  background: linear-gradient(180deg,\n    rgba(255, 253, 247, 0.85) 0%,\n    rgba(250, 248, 242, 0.72) 100%);\n  box-shadow:\n    0 16px 40px -12px rgba(46, 11, 18, 0.18),\n    inset 0 1px 0 rgba(255, 255, 255, 1),\n    inset 0 -1px 0 rgba(74, 13, 24, 0.05);\n  border-color: rgba(74, 13, 24, 0.22);\n}\n\n/* ================================================================\n   Buttons (§4 & §5)\n   - .pf-btn-primary  → green accent CTA (Reveal, Get Deal, Sign in…)\n   - .pf-btn-burgundy → burgundy secondary on light bg\n   - .pf-btn-glass    → subtle secondary on cream\n   ================================================================ */\n.pf-btn-primary {\n  background: var(--cy-accent);\n  color: #1A1A1A;\n  font-weight: 600;\n  border: 1px solid rgba(74, 13, 24, 0.08);\n  border-radius: 12px;\n  box-shadow:\n    0 4px 14px -4px rgba(94, 118, 44, 0.35),\n    inset 0 1px 0 rgba(255, 255, 255, 0.35);\n  transition:\n    background-color 160ms ease,\n    transform 140ms ease,\n    box-shadow 200ms ease;\n}\n.pf-btn-primary:hover {\n  background: var(--cy-accent-hover);\n  box-shadow:\n    0 8px 22px -6px rgba(94, 118, 44, 0.45),\n    inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n.pf-btn-primary:active {\n  background: var(--cy-accent-active);\n  transform: scale(0.98);\n}\n.pf-btn-primary:disabled {\n  background: var(--cy-muted-bg);\n  color: var(--cy-text-muted);\n  box-shadow: none;\n  cursor: not-allowed;\n}\n:root.dark .pf-btn-primary {\n  color: #1A1A1A;\n}\n\n/* Burgundy button — secondary action on light bg */\n.pf-btn-burgundy {\n  background: var(--cy-burgundy);\n  color: var(--cy-text-on-dark);\n  font-weight: 600;\n  border: 1px solid rgba(46, 11, 18, 0.6);\n  border-radius: 12px;\n  box-shadow:\n    0 4px 14px -4px rgba(46, 11, 18, 0.35),\n    inset 0 1px 0 rgba(255, 253, 247, 0.15);\n  transition: background-color 160ms ease, transform 140ms ease, box-shadow 200ms ease;\n}\n.pf-btn-burgundy:hover { background: #5C1422; }\n.pf-btn-burgundy:active { background: var(--cy-burgundy-dark); transform: scale(0.98); }\n\n/* Glass / secondary button on cream */\n.pf-btn-glass {\n  background-color: var(--cy-surface);\n  border: 1px solid var(--cy-border);\n  color: var(--cy-text);\n  font-weight: 600;\n  border-radius: 12px;\n  transition:\n    background-color 200ms ease,\n    border-color 200ms ease,\n    color 200ms ease;\n}\n.pf-btn-glass:hover {\n  background-color: var(--cy-muted-bg);\n  border-color: var(--cy-burgundy);\n  color: var(--cy-burgundy);\n}\n\n.pf-btn-secondary {\n  background: var(--cy-surface);\n  color: var(--cy-burgundy);\n  border: 1px solid var(--cy-border);\n  border-radius: 12px;\n  font-weight: 600;\n  transition: background-color 180ms ease, border-color 180ms ease;\n}\n.pf-btn-secondary:hover {\n  background: var(--cy-muted-bg);\n  border-color: var(--cy-burgundy);\n}\n\n/* ================================================================\n   Chips (§10 + §general) — burgundy pills for badges,\n   green pills for cashback/accent, cream for neutral\n   ================================================================ */\n.pf-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: var(--cy-muted-bg);\n  border: 1px solid var(--cy-border);\n  color: var(--cy-burgundy);\n  box-shadow: 0 2px 6px rgba(46, 11, 18, 0.04);\n}\n/* Legacy chip variants remapped to the new palette */\n.pf-chip-cyan {  /* → burgundy badge */\n  background: var(--cy-burgundy);\n  border-color: var(--cy-burgundy-dark);\n  color: var(--cy-text-on-dark);\n}\n.pf-chip-lav {   /* → warm cream badge */\n  background: var(--cy-muted-bg);\n  border-color: var(--cy-border);\n  color: var(--cy-burgundy);\n}\n.pf-chip-mint {  /* → green accent — cashback / rewards */\n  background: var(--cy-accent);\n  border-color: rgba(74, 13, 24, 0.15);\n  color: var(--cy-text);\n}\n\n/* ================================================================\n   Divider · Marquee · Fade · Gradient shift\n   ================================================================ */\n.pf-divider {\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(74, 13, 24, 0.2), transparent);\n  margin: 0 auto;\n  max-width: 90rem;\n}\n\n.marquee { animation: marquee 45s linear infinite; }\n@keyframes marquee {\n  from { transform: translateX(0); }\n  to   { transform: translateX(-50%); }\n}\n\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(12px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.fade-up { animation: fadeUp 600ms ease both; }\n\n@keyframes gradient-shift {\n  0%, 100% { background-position: 0% 50%; }\n  50%      { background-position: 100% 50%; }\n}\n.gradient-shift {\n  background-size: 200% 200%;\n  animation: gradient-shift 10s ease infinite;\n}\n\n/* ================================================================\n   Inputs (§11)\n   ================================================================ */\n.pf-input {\n  background: rgba(250, 248, 242, 0.72);\n  backdrop-filter: blur(12px) saturate(140%);\n  -webkit-backdrop-filter: blur(12px) saturate(140%);\n  border: 1px solid rgba(74, 13, 24, 0.15);\n  color: var(--cy-text);\n  border-radius: 10px;\n  transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;\n}\n.pf-input::placeholder { color: var(--cy-placeholder); }\n.pf-input:focus {\n  outline: none;\n  border-color: var(--cy-burgundy);\n  box-shadow: 0 0 0 4px var(--cy-focus-ring);\n}\n.pf-input:disabled {\n  background: var(--cy-muted-bg);\n  color: var(--cy-text-muted);\n}\n.pf-input[aria-invalid=\"true\"],\n.pf-input.error {\n  border-color: var(--cy-error);\n  box-shadow: 0 0 0 4px rgba(180, 35, 24, 0.12);\n}\n\n/* ================================================================\n   Scrollbar\n   ================================================================ */\n::-webkit-scrollbar { width: 10px; height: 10px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb {\n  background: rgba(74, 13, 24, 0.28);\n  border-radius: 8px;\n}\n::-webkit-scrollbar-thumb:hover { background: rgba(74, 13, 24, 0.5); }\n\n.tabular-nums { font-variant-numeric: tabular-nums; }\n\n/* ================================================================\n   Shimmer sweep — used on featured cards, warmed for cream base\n   ================================================================ */\n.shimmer {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n}\n.shimmer::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    115deg,\n    transparent 30%,\n    rgba(255, 253, 247, 0.55) 48%,\n    rgba(235, 231, 222, 0.35) 52%,\n    transparent 70%\n  );\n  background-size: 250% 100%;\n  background-position: 200% 0;\n  pointer-events: none;\n  animation: shimmer-sweep 4.5s ease-in-out infinite;\n  mix-blend-mode: overlay;\n  z-index: 1;\n}\n@keyframes shimmer-sweep {\n  0%   { background-position: 200% 0; }\n  55%  { background-position: -50% 0; }\n  100% { background-position: -50% 0; }\n}\n.shimmer > * { position: relative; z-index: 2; }\n\n/* ================================================================\n   Burgundy console sidebar (§8) — used by merchant portal via\n   <PortalShell variant=\"burgundy\">. Dark burgundy surface with\n   accent-green pill highlight on the selected tab.\n   ================================================================ */\n.console-burgundy {\n  background: linear-gradient(180deg, #2E0B12 0%, #4A0D18 100%);\n  border: 1px solid rgba(255, 253, 247, 0.08);\n  color: var(--cy-text-on-dark);\n  box-shadow:\n    0 20px 50px -15px rgba(46, 11, 18, 0.45),\n    inset 0 1px 0 rgba(255, 253, 247, 0.06);\n  /* No blur — solid burgundy console reads more premium than a translucent one */\n}\n\n.console-burgundy__eyebrow {\n  color: rgba(216, 200, 197, 0.75);\n}\n.console-burgundy__title {\n  color: var(--cy-text-on-dark);\n}\n\n.console-burgundy__link {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  padding: 0.625rem 0.875rem;\n  border-radius: 12px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--cy-text-on-dark-muted);\n  position: relative;\n  transition:\n    background-color 180ms ease,\n    color 180ms ease,\n    padding-left 180ms ease;\n}\n.console-burgundy__link:hover {\n  background: rgba(255, 253, 247, 0.08);\n  color: var(--cy-text-on-dark);\n}\n.console-burgundy__link--active {\n  background: rgba(255, 253, 247, 0.10);\n  color: var(--cy-text-on-dark);\n  padding-left: 1.125rem;\n}\n/* Green accent indicator bar on the active tab (spec §8) */\n.console-burgundy__link--active::before {\n  content: \"\";\n  position: absolute;\n  left: 0.375rem;\n  top: 25%;\n  bottom: 25%;\n  width: 3px;\n  border-radius: 4px;\n  background: var(--cy-accent);\n  box-shadow: 0 0 12px rgba(168, 216, 93, 0.6);\n}\n/* Icon color follows text; boost the active-state icon */\n.console-burgundy__link svg { color: currentColor; }\n.console-burgundy__link--active svg { color: var(--cy-accent); }\n\n:root.dark .console-burgundy {\n  background: linear-gradient(180deg, #180508 0%, #2E0B12 100%);\n}\n\n@layer base {\n  * { border-color: hsl(var(--border)); }\n}\n\n/* Floating helpers step aside while a dialog or sheet is open. */\nbody[data-scroll-locked] .support-chat-launcher-btn,\nbody[data-scroll-locked] [data-testid=\"analytics-consent-banner\"] { display: none !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
